{
  "app": {
    "name": "miraCMS 2.0",
    "tagline": "Click-to-Edit Editor"
  },
  "audit": {
    "title": "Protokoll",
    "hint": "Wer hat wann was geändert. Unveränderlich, mit fälschungssicherer Kette.",
    "chainBroken": "Achtung: Am Protokoll wurde manipuliert (ab Zeile {line}). Bitte umgehend prüfen.",
    "empty": "Noch keine Einträge.",
    "loading": "Lädt …",
    "more": "Mehr laden",
    "all": "Alle",
    "days7": "Letzte 7 Tage",
    "days30": "Letzte 30 Tage",
    "days90": "Letzte 90 Tage",
    "count": "{n} Eintrag | {n} Einträge",
    "filterProject": "Projekt",
    "filterPeriod": "Zeitraum",
    "filterActor": "Person",
    "colWhen": "Wann",
    "colWho": "Wer",
    "colWhat": "Was",
    "colProject": "Projekt",
    "outcome": {
      "denied": "abgewiesen",
      "failed": "fehlgeschlagen"
    },
    "area": {
      "project": "Projekt",
      "user": "Zugang",
      "auth": "Anmeldung",
      "gate_texts": "Vorschau-Seite"
    },
    "verb": {
      "saved": "Gespeichert",
      "created": "Angelegt",
      "updated": "Geändert",
      "deleted": "Gelöscht",
      "publish": "Veröffentlicht",
      "promote": "Live gestellt",
      "login": "Angemeldet",
      "logout": "Abgemeldet",
      "password_changed": "Passwort geändert",
      "upload": "Hochgeladen",
      "restore": "Wiederhergestellt",
      "reorder": "Umsortiert",
      "save": "Gespeichert",
      "totp": "Zweiter Faktor bestätigt",
      "gast": "Über Kommentar-Link angemeldet",
      "annotations": "Kommentar",
      "replies": "Antwort auf Kommentar",
      "anhaenge": "Anhang am Kommentar",
      "gast-link": "Kommentar-Link",
      "items": "Katalog-Eintrag",
      "module": "Zugriff geändert",
      "rebuild": "Vorschau neu gebaut",
      "seiten": "Seite",
      "share": "Vorschau-Link",
      "upload-file": "Datei hochgeladen",
      "password": "Passwort geändert"
    }
  },
  "update": {
    "available": "Eine neue Version ist verfügbar.",
    "action": "Jetzt aktualisieren"
  },
  "changelog": {
    "title": "Neu seit dem letzten Update",
    "dismiss": "Ausblenden",
    "entries": {
      "premium-wirkung": "Neu für Seiten aus Bausteinen: eine Überzeile über jeder Überschrift, „Text mit Bild“ randlos mit Glaskarten, Vorteile als Glaskarten, ein bildschirmfüllender Einstieg mit großer Überschrift und Hinweis zum Weiterscrollen sowie Knöpfe mit feinem Rahmen in der Akzentfarbe.",
      "kopf-ueber-bild-hell": "Die Kopfzeile kann jetzt auch auf hellen Stilen durchsichtig auf dem Bild im Einstieg liegen, mit weißer Schrift und der hellen Fassung Ihres Logos.",
      "bild-im-chat": "Im Chatfenster des Assistenten hängen Sie jetzt bis zu drei eigene Bilder an. Sie landen in der Mediathek, und Claude sieht sie, bevor es sie einsetzt und beschreibt.",
      "baustein-gutschein": "Neuer Baustein „Gutschein“: eine Gutscheinkarte in Ihren Farben mit dem Namen Ihres Betriebs, daneben Text und ein Knopf zum Kauf.",
      "baustein-buchung": "Neuer Baustein „Online buchen“: Er zeigt Ihre Angebote mit Dauer und Preis direkt aus der Online-Buchung, jedes mit Knopf zum Termin. Die Preise pflegen Sie nur noch dort.",
      "kopf-ueber-bild": "Auf Websites mit dunklem Seitenhintergrund kann die Kopfzeile jetzt durchsichtig auf dem Bild im Einstieg liegen. Einzuschalten unter Gestaltung, die Stilrichtung „Edel & Dunkel“ tut es von selbst.",
      "abdunklung-waehlbar": "Liegt Text auf einem Bild, im Einstieg oder als Hintergrund eines Abschnitts, wählen Sie im Menü des Abschnitts, wie stark das Bild abgedunkelt wird: leicht, normal oder stark.",
      "stil-edel-dunkel": "Neue Stilrichtung „Edel & Dunkel“: die ganze Website dunkel, Lavendel und Gold, feine Serifen. Unter Gestaltung lässt sich dazu ein Sternenhimmel als Muster im Hintergrund einschalten.",
      "vorschau-link-cloudflare": "Den Vorschau-Link gibt es jetzt auch für Websites bei Cloudflare. Er öffnet die Vorschau im Browser, auch auf dem Handy, und lässt sich an die Kundin oder den Kunden weiterschicken.",
      "claude-ganze-seite": "Wo der Assistent freigeschaltet ist, baut Claude auf Wunsch eine ganze Seite in einem Schritt und ordnet das Menü. Unten steht, was das Gespräch bisher gekostet hat.",
      "claude-gestaltung": "Wo der Assistent freigeschaltet ist, ändert Claude jetzt auch das Aussehen: Stilrichtung, Farben und Schriften, wie alles nur in der Vorschau.",
      "stockfotos": "Beim Bildfeld gibt es den Reiter Stockfotos: Fotos von Pexels und Pixabay suchen und mit einem Klick übernehmen. Wo der Assistent freigeschaltet ist, sucht und setzt auch Claude Fotos ein.",
      "neue-bausteine-premium": "Neue Bausteine Kennzahlen, Vorteile, Zitat und Bild breit, dazu Bilder im Einstieg, als Hintergrund jedes Abschnitts und je Leistung oder Preis.",
      "stilrichtungen": "Unter Gestaltung gibt es fertige Stilrichtungen, die Farben, Schriften und Ecken zusammen setzen, und eine eigene Schrift für Überschriften.",
      "bild-alle-sprachen": "Ein Bild in einem Abschnitt tauschen Sie jetzt einmal, es gilt für alle Sprachen der Seite. Die Bildbeschreibung bleibt je Sprache.",
      "mediathek": "Die neue Mediathek zeigt alle Bilder des Projekts und wo sie stehen; mit „Aus der Mediathek“ setzen Sie ein vorhandenes Bild in ein Bildfeld, statt es noch einmal hochzuladen, und hochgeladene Bilder, die nirgends mehr stehen, löschen Sie dort.",
      "vorabpruefung": "Vor „Auf Live“ prüft miraCMS jetzt die Website: Platzhalter müssen ersetzt sein, fehlende Bildbeschreibungen und Überschriften stehen als Empfehlung da, und ein Klick führt zur Stelle.",
      "neue-bausteine": "Für Websites aus Bausteinen gibt es acht neue: Galerie, Preisliste, Team, Öffnungszeiten, Karte, Kontaktformular, Video und Bewertungen.",
      "rueckgaengig": "Umbauten lassen sich rückgängig machen: mit Cmd+Z oder dem Pfeil unter den Abschnitten, Cmd+Shift+Z stellt sie wieder her.",
      "menue-und-adresse": "Das Menü der Website pflegen Sie jetzt selbst, mit „Menü bearbeiten“ unter der Seitenliste, und bei Seiten aus Bausteinen lässt sich die Adresse ändern, alte Links leiten dabei weiter.",
      "assistent-im-panel": "Wo miraTEQ es freischaltet, gibt es rechts den Reiter „Assistent“: Sie schreiben, was sich ändern soll, und Claude erledigt es in der Vorschau.",
      "seitenwechsel-ohne-speichern": "Sie können die Seite wechseln, ohne vorher zu speichern: Ungespeichertes bleibt stehen, ein Punkt in der Seitenliste zeigt, wo, und Speichern sichert alles zusammen.",
      "umbauten-sofort": "Umbauten an Abschnitten sind jetzt sofort zu sehen, und nach dem Speichern aktualisiert sich die Vorschau, ohne an den Anfang zu springen.",
      "seiten-aus-bausteinen": "Bei Websites aus Bausteinen legen Sie im Reiter „Abschnitte“ neue Abschnitte und ganze Seiten an, verschieben und löschen sie.",
      "verlauf-mit-namen": "Im Verlauf eines Feldes steht bei neuen Änderungen jetzt, wer sie gemacht hat.",
      "bildbeschreibung-pruefen": "Nach einem Bildtausch steht die Bildbeschreibung auf „Bitte prüfen“, bis Sie sie anpassen oder mit „Passt so“ bestätigen.",
      "neue-website": "Neue Kundenwebsites legen Sie jetzt selbst im Panel an: „Neue Website“ in der Projektliste, danach im Projekt „Einrichtung“ für Domain, Kontaktformular und Freigabe des Kunden. Heikle Schritte bestätigen Sie mit dem Code aus Ihrer App.",
      "schrift-und-ecken": "Unter Farben wählen Sie jetzt auch Schrift und Ecken, und eine zu helle Markenfarbe bekommt für Knöpfe von selbst einen gut lesbaren Ton.",
      "schrift-editor": "Texte in den Abschnitten lassen sich jetzt gestalten: fett, kursiv, als Link, in Marken- oder Akzentfarbe, gedämpft, größer oder kleiner und markiert.",
      "schrift-und-farben": "Unter Farben stellen Sie jetzt Größe, Stärke und Buchstabenabstand der Überschriften, die Textgröße, eine Akzentfarbe und den Seitenhintergrund ein, und Abschnitte gibt es auch ganz in der Markenfarbe.",
      "abschnitt-einstellungen": "Im Menü eines Abschnitts stellen Sie jetzt den Abstand ein, geben ihm eine Sprungmarke, zu der ein Knopf springt, oder blenden ihn aus, ohne ihn zu löschen.",
      "knoepfe-kopf-social": "Unter Farben wählen Sie jetzt den Stil der Knöpfe und ob die Kopfzeile beim Scrollen oben bleibt; Instagram, Facebook, LINE und weitere Profile tragen Sie bei den Feldern für alle Seiten ein, sie stehen dann unten auf jeder Seite.",
      "bildausschnitt": "Unter einem Bild im Abschnitt wählen Sie jetzt den Bildausschnitt: Der gewählte Teil bleibt sichtbar, wenn das Bild auf dem Handy beschnitten wird.",
      "seiten-vorlagen-kopie": "Neue Seiten beginnen auf Wunsch mit einer Vorlage wie Leistungen, Preise oder Über uns, Seiten aus Abschnitten lassen sich kopieren, und die Prüfung vor dem Veröffentlichen nennt leere Seitentitel und Beschreibungen für Suchmaschinen.",
      "symbole-ankuendigung": "Vorteile und Leistungen bekommen auf Wunsch ein Symbol aus einer festen Auswahl, und bei den Feldern für alle Seiten tragen Sie eine Ankündigung ein, die ganz oben auf jeder Seite steht.",
      "zuruecknehmen-cloudflare": "Die letzte Veröffentlichung lässt sich jetzt immer zurücknehmen, auch bei Websites bei Cloudflare: „Auf Live“ öffnet sich dafür auch dann, wenn nichts Neues zu veröffentlichen ist.",
      "ki-bilder": "Neuer Reiter „KI-Bild“ im Bildfenster: Sie beschreiben, was das Bild zeigen soll, und erhalten ein passendes Foto, auch Claude kann so Bilder erzeugen.",
      "baustein-logos": "Neuer Baustein Logos: Partner, Zertifikate oder Auszeichnungen als Reihe oder in Kacheln, einfarbig oder in Originalfarben.",
      "seite-ohne-suche": "Im Menü einer Seite gibt es „Nicht in Suchmaschinen zeigen“: Die Seite bleibt auf der Website, Google nimmt sie aber nicht auf, etwa eine Danke-Seite.",
      "kontaktseite-bausteine": "Neue Websites bekommen eine Kontaktseite aus Bausteinen: Einstieg, Formular neben Telefon und E-Mail, Anfahrt mit Karte. Alles lässt sich wie jede andere Seite umbauen.",
      "logo-hell-branche": "Unter „Für alle Seiten“ gibt es ein helles Logo für dunkle Stile, die Branche für Google und die Angabe, ob die Zeiten Öffnungszeiten sind. Dann zeigt Google sie an.",
      "mit-claude-uebersetzen": "Im Menü jeder Seite einer mehrsprachigen Website steht „Mit Claude übersetzen“: Claude füllt alle weiteren Sprachen in der Vorschau.",
      "bewegung-parallaxe": "Unter Gestaltung wählen Sie jetzt, wie Abschnitte beim Scrollen erscheinen, und ob große Bilder sich mitbewegen. Wer am Gerät weniger Bewegung eingestellt hat, sieht keine.",
      "kopf-einblendend": "Die Kopfzeile kann jetzt beim Lesen verschwinden und beim Hochscrollen wiederkommen, mit leichtem Schatten. Einstellbar unter Gestaltung, Kopfzeile beim Scrollen.",
      "schrift-paare": "Unter Gestaltung gibt es Schrift-Paare: Überschrift und Text, die zusammen gut aussehen, mit einem Klick.",
      "neue-darstellungen": "Neue Darstellungen: Galerie als Streifen oder Slideshow, Stimmen als Karussell oder große Einzelstimme, Preise als Pakete mit einem hervorgehobenen Angebot.",
      "fuss-varianten": "Die Fußzeile gibt es jetzt in drei Arten: zweispaltig, in Spalten mit Überschriften und schlicht mittig. Einstellbar unter Gestaltung.",
      "kopf-varianten": "Die Kopfzeile kann jetzt Logo und Menü mittig zeigen, und das Menü auf dem Handy öffnet sich auf Wunsch über den ganzen Bildschirm.",
      "baustein-speisekarte": "Neuer Baustein Speisekarte: Gerichte nach Kategorien, mit Preis, Etiketten wie vegan oder scharf, in Euro oder Baht.",
      "baustein-zimmer": "Neuer Baustein Zimmer: Foto, Größe, Personen, Preis und Ausstattung, mit Knopf zur Buchung, als Karten oder groß im Wechsel.",
      "baustein-vorher-nachher": "Neuer Baustein Vorher/Nachher: zwei Fotos übereinander, ein Regler zeigt den Unterschied.",
      "bild-look": "Unter Gestaltung wählen Sie einen Bild-Look für alle Fotos, etwa warm oder sanft. So wirken eigene Fotos, Stockfotos und KI-Bilder wie aus einer Hand. Logos bleiben unverändert.",
      "schwebeknopf-laufband": "Neu: ein schwebender Knopf unten rechts zu WhatsApp, LINE oder zum Telefon, Logos als Laufband, und Küche und Preisniveau für Google. Alles unter „Für alle Seiten“ und in den Abschnitten.",
      "abschnitt-geraet": "Im Menü jedes Abschnitts gibt es „Sichtbar auf“: allen Geräten, nur auf dem Handy oder nur ab Tablet.",
      "formular-zusatzfelder": "Das Kontaktformular kann jetzt zusätzlich nach Telefon, Wunschtermin und Personenzahl fragen, je aus, freiwillig oder Pflicht.",
      "untermenue": "Im Menü-Fenster lässt sich eine Seite unter die Seite darüber einrücken. Auf der Website erscheint sie dann als Untermenü.",
      "bewegung-tempo": "Unter Gestaltung gibt es jetzt das Tempo der Einblendung, ruhig bis lebhaft. Im Menü jedes Abschnitts lässt sich die Bewegung für diesen Abschnitt eigens wählen oder abschalten.",
      "branchenpaket": "Bei „Neue Website“ wählen Sie jetzt eine Branche. Die Website startet dann mit passendem Stil, einer fertig gegliederten Startseite und zwei bis drei Seiten, etwa Massagen, Gutscheine und Über uns.",
      "formular-ohne-haekchen": "Das Kontaktformular neuer Websites hat kein Einwilligungshäkchen mehr. Darunter steht ein kurzer Hinweis mit Link zur Datenschutzerklärung, den Sie im Abschnitt ändern können.",
      "anfragen-im-panel": "Anfragen aus dem Kontaktformular stehen jetzt auch im CMS, oben unter „Anfragen“: lesen, per E-Mail antworten, löschen. Nach sechs Monaten löscht das CMS sie automatisch.",
      "landingpage": "Im Menü einer Seite gibt es „Als Landingpage“: Oben stehen dann nur Logo und Knopf, ohne Menü. Gut für Werbe- und Angebotsseiten.",
      "faq-aufklappen": "Im Abschnitt „Häufige Fragen“ wählen Sie jetzt, ob die erste Frage offen ist und ob immer nur eine aufgeht. Auswahlfelder in Abschnitten gelten außerdem in allen Sprachen der Seite.",
      "kleine-reste-vorlage": "Neu in der Vorlage: Telefon und Netzwerke unten im Handy-Menü, bei „Text mit Bild“ die Bildbreite und ob das Bild am Handy über dem Text steht, und in der Speisekarte ein zweiter Preis je Gericht, etwa klein und groß.",
      "menue-links": "Eigene Links im Menü: Unter „Für alle Seiten“ tragen Sie bis zu vier Links mit Name und Ziel ein, etwa zur Online-Buchung oder zu einer Stelle wie „/#preise“. Im Fenster „Menü“ setzen Sie sie dann wie Seiten in Kopf oder Fuß.",
      "hero-video": "Im Einstieg mit Bild lässt sich jetzt ein kurzes Video statt des stehenden Bildes zeigen. Es hat einen Knopf zum Anhalten und lädt nicht bei „weniger Bewegung“ oder Datensparen.",
      "markenprofil": "Neu im Chatfenster: ein Markenprofil, das Claude bei jedem Auftrag mitbekommt. An jedem Textfeld gibt es „Kürzer“, „Freundlicher“ und „Andere Fassung“, und vor dem Veröffentlichen „Erst von Claude prüfen lassen“.",
      "neuigkeiten-blog": "Neuigkeiten und Blog: Eine Seite aus der Vorlage „Beitrag“ bekommt ein Datum und erscheint im neuen Abschnitt „Neuigkeiten“, die Vorlage „Neuigkeiten“ zeigt alle. Dazu der Baustein „Text“ für lange Artikel mit Zwischenüberschriften.",
      "sprachen-ergaenzen": "Neu oben in der Leiste: „Sprachen“. Eine Website bekommt dort eine weitere Sprache, Claude übersetzt sie auf Wunsch ganz, und live geht sie erst nach „Freigeben“."
    }
  },
  "nav": {
    "audit": "Protokoll",
    "projects": "Projekte",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "konto": "Konto",
    "projekt": "Projekt",
    "bearbeiten": "Bearbeiten",
    "kataloge": "Kataloge",
    "farben": "Farben",
    "nicht_gefunden": "Nicht gefunden",
    "editor": "Editor"
  },
  "projects": {
    "title": "Alle Projekte",
    "subtitle": "{n} Kundenseite. Öffnen Sie sie zum Bearbeiten. | {n} Kundenseiten. Wählen Sie eine zum Bearbeiten.",
    "search": "Suchen…",
    "empty": "Noch keine Projekte. Legen Sie eine Customer-Site mit app.json an.",
    "open": "Öffnen",
    "schema_ok": "Schema OK",
    "schema_missing": "Kein Schema",
    "sites": "Sites",
    "default_lang": "Sprache"
  },
  "project_detail": {
    "back": "← Zurück",
    "site": "Site",
    "lang": "Sprache",
    "fields_count": "{n} Feld | {n} Felder",
    "loading": "Wird geladen…",
    "synchron": "Staging und Live sind synchron",
    "seit_live": "{n} Änderung seit Live | {n} Änderungen seit Live",
    "eintraege_verwalten": "{n} Eintrag selbst verwalten → | {n} Einträge selbst verwalten →",
    "farben_aendern": "{n} Marken-Farbe ändern → | {n} Marken-Farben ändern →",
    "schema_status": "Schema-Status: {status}",
    "schema_fehlt": "✗ fehlt",
    "schema_vorhanden": "✓ ok"
  },
  "login": {
    "title": "Anmelden",
    "laeuft": "Wird angemeldet …",
    "bitte_anmelden": "Bitte melden Sie sich an",
    "bestaetigen": "Bestätigen",
    "prueft": "Wird geprüft …",
    "recovery_hinweis": "Kein Zugriff auf die App? Geben Sie stattdessen einen Recovery-Code ein, zum Beispiel {beispiel}.",
    "fehler": {
      "invalid_credentials": "Benutzername oder Passwort stimmt nicht.",
      "missing_credentials": "Bitte geben Sie Benutzername und Passwort ein.",
      "invalid_code": "Der Code stimmt nicht. Bitte versuchen Sie es noch einmal.",
      "invalid_token": "Die Anmeldung ist abgelaufen. Bitte beginnen Sie noch einmal von vorn.",
      "rate_limited": "Zu viele Versuche. Bitte warten Sie {n} Minute. | Zu viele Versuche. Bitte warten Sie {n} Minuten.",
      "unbekannt": "Die Anmeldung hat nicht geklappt ({grund})."
    }
  },
  "errors": {
    "load_failed": "Laden fehlgeschlagen",
    "save_failed": "Speichern fehlgeschlagen",
    "network": "Netzwerk-Fehler"
  },
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "retry": "Erneut versuchen"
  },
  "publish": {
    "titel": "Auf Live veröffentlichen",
    "ziel": "Alle Änderungen aus miraCMS kommen auf die Website.",
    "laedt": "Änderungen werden geladen …",
    "nichtsTitel": "Nichts zu veröffentlichen",
    "nichtsText": "Die Website zeigt schon den neuesten Stand.",
    "aenderungen": "{n} Änderung wird veröffentlicht. | {n} Änderungen werden veröffentlicht.",
    "seiten": "Betrifft {n} Seite. | Betrifft {n} Seiten.",
    "abbrechen": "Abbrechen",
    "jetzt": "Jetzt veröffentlichen",
    "laeuft": "Wird veröffentlicht …",
    "erfolg": "Veröffentlicht. Die Änderungen sind jetzt auf der Website.",
    "einzelheiten": "Technische Einzelheiten",
    "hinweisGespeichert": "Während des Veröffentlichens wurde noch etwas gespeichert. Das ist noch nicht draußen. Bitte veröffentlichen Sie gleich noch einmal.",
    "fehler": {
      "titel": "Nicht veröffentlicht",
      "nichts": "Es gibt nichts zu veröffentlichen. Die Website zeigt schon den neuesten Stand.",
      "beschaeftigt": "Gerade läuft schon eine Veröffentlichung. Bitte warten Sie einen Moment und versuchen Sie es dann noch einmal.",
      "pruefungFehlt": "Der Server konnte den Speicherort der Texte nicht erreichen. Es wurde nichts veröffentlicht. Bitte versuchen Sie es in ein paar Minuten noch einmal.",
      "livevoraus": "Auf der Website stehen Änderungen, die nicht aus miraCMS kommen. Es wurde nichts veröffentlicht. Bitte melden Sie sich bei miraTEQ.",
      "bauFehler": "Die Website konnte nicht neu erstellt werden. Es wurde nichts veröffentlicht, draußen steht unverändert die alte Fassung. Bitte melden Sie sich bei miraTEQ.",
      "ungesichert": "Auf dem Server liegt Arbeit, die noch nicht gesichert ist. Es wurde nichts veröffentlicht. Bitte melden Sie sich bei miraTEQ.",
      "sicherung": "Vor dem Veröffentlichen konnte keine Sicherungskopie angelegt werden. Es wurde nichts veröffentlicht. Bitte melden Sie sich bei miraTEQ.",
      "freigabe": "Die Website ist aktualisiert, aber ein technischer Vermerk konnte nicht gespeichert werden. Bitte melden Sie sich bei miraTEQ.",
      "unbekannt": "Beim Veröffentlichen ist etwas schiefgegangen. Es wurde nichts veröffentlicht. Bitte melden Sie sich bei miraTEQ.",
      "cloudflareZugang": "Es wurde nichts veröffentlicht, die Website ist unverändert. Für ihren Platz bei Cloudflare fehlt der Zugang. Bitte melden Sie sich bei miraTEQ.",
      "cloudflareLesen": "Es wurde nichts veröffentlicht, die Website ist unverändert. Cloudflare hat nicht gemeldet, welche Fassung gerade läuft, und ohne diese Angabe ließe sich später nicht zurücknehmen. Bitte versuchen Sie es in ein paar Minuten noch einmal.",
      "hochladen": "Es wurde nichts veröffentlicht, die Website ist unverändert. Das Hochladen zu Cloudflare hat nicht geklappt. Bitte melden Sie sich bei miraTEQ.",
      "baubefehlAlt": "Es wurde nichts veröffentlicht. Die Einstellungen dieses Projekts sind veraltet. Bitte melden Sie sich bei miraTEQ."
    },
    "zurueck": {
      "knopf": "Letzte Veröffentlichung zurücknehmen",
      "stand": "Die Website zeigt dann wieder den Stand von {zeit}.",
      "hinweis": "Ihre Texte in miraCMS bleiben, wie sie sind.",
      "laeuft": "Wird zurückgenommen …",
      "erfolg": "Die Website zeigt wieder den vorherigen Stand.",
      "teilweise": "Die Website zeigt wieder den vorherigen Stand. Ein technischer Vermerk konnte nicht zurückgesetzt werden, bitte melden Sie sich bei miraTEQ.",
      "fehler": {
        "titel": "Nicht zurückgenommen",
        "nichtMoeglich": "Für dieses Projekt gibt es keine Sicherungskopie zum Zurücknehmen.",
        "keine": "Es gibt noch nichts zurückzunehmen.",
        "veraltet": "Seitdem wurde erneut veröffentlicht. Dieser Stand lässt sich nicht mehr zurückholen.",
        "unbekannt": "Das Zurücknehmen hat nicht geklappt. Bitte melden Sie sich bei miraTEQ.",
        "umschalten": "Die Website zeigt weiter den neuen Stand. Cloudflare hat das Umschalten abgelehnt. Bitte melden Sie sich bei miraTEQ.",
        "cloudflareLesen": "Nichts wurde zurückgenommen. Cloudflare hat nicht gemeldet, welche Fassung gerade läuft. Bitte versuchen Sie es in ein paar Minuten noch einmal."
      }
    },
    "erster_livegang_fehlt": "Für den ersten Livegang fehlt noch:",
    "in_einrichtung": "Das erledigen Sie unter „Einrichtung“ oben in der Leiste.",
    "erster_livegang_laeuft": "Die Website ist hochgeladen und wird jetzt an ihre Domain gehängt.",
    "rauchtest_zurueck": "Die Website antwortete nach dem Hochladen nicht richtig. miraCMS hat die vorige Fassung wieder eingeschaltet, die Besucher sehen den alten Stand.",
    "rauchtest_fehler": "Die Website antwortete nach dem Hochladen nicht richtig, und die vorige Fassung ließ sich nicht wieder einschalten. Bitte sofort miraTEQ Bescheid geben."
  },
  "vorab": {
    "alle_seiten": "Auf allen Seiten",
    "muss_titel": "Vor dem Veröffentlichen beheben: {n} Stelle | Vor dem Veröffentlichen beheben: {n} Stellen",
    "muss_hinweis": "Hier stehen noch Platzhalter aus der Vorlage. Ein Klick führt zum Feld.",
    "weitere": "{n} weitere zeigen | {n} weitere zeigen",
    "soll_titel": "{n} Empfehlung | {n} Empfehlungen",
    "alles_gut": "Geprüft: keine Platzhalter, alle Bilder beschrieben, Überschriften in Ordnung.",
    "gekuerzt": "{n} weitere Funde sind hier nicht aufgeführt.",
    "gesperrt": "Erst die Platzhalter ersetzen",
    "art": {
      "platzhalter": "{seite}: „{feld}“ ist noch ein Platzhalter",
      "platzhalter_bild": "{seite}: Das Bild „{feld}“ ist noch das Platzhalterbild",
      "bild_ohne_beschreibung": "{seite}: „{feld}“ ist leer, das Bild hat keine Beschreibung",
      "beschreibung_pruefen": "{seite}: Bildbeschreibung nach dem Bildtausch prüfen",
      "h1_fehlt": "{seite} hat keine Hauptüberschrift",
      "h1_mehrfach": "{seite} hat {n} Hauptüberschriften statt einer | {seite} hat {n} Hauptüberschriften statt einer",
      "ueberschrift_sprung": "{seite}: Eine Überschriftenebene ist übersprungen | {seite}: {n}-mal ist eine Überschriftenebene übersprungen",
      "bild_ohne_alt": "{seite}: Ein Bild im Aufbau der Seite hat keine Beschreibung, das behebt miraTEQ | {seite}: {n} Bilder im Aufbau der Seite haben keine Beschreibung, das behebt miraTEQ",
      "link_ohne_text": "{seite}: Ein Link hat keinen lesbaren Namen, das behebt miraTEQ | {seite}: {n} Links haben keinen lesbaren Namen, das behebt miraTEQ",
      "pflicht_fehlt": "{seite}: „{feld}“ ist leer, das ist eine Pflichtangabe",
      "seo_titel_fehlt": "{seite}: Der Seitentitel für Suchmaschinen ist leer",
      "seo_beschreibung_fehlt": "{seite}: Die Beschreibung für Suchmaschinen ist leer"
    }
  },
  "kopf": {
    "suchen": "Suchen",
    "suchen_titel": "Suchen (Cmd+K)",
    "bereich": "Bereich wählen"
  },
  "projekt": {
    "vorschau_link": "Vorschau-Link",
    "vorschau_link_hinweis": "Zum Ansehen, mit Ablauf",
    "zugriff": "Zugriff",
    "zugriff_hinweis": "Wer an dieses Projekt darf",
    "verlauf": "Verlauf",
    "verlauf_hinweis": "Wer wann was geändert hat",
    "kataloge": "Kataloge",
    "auf_live": "Auf Live",
    "auf_live_nichts": "Vorschau und Live sind gleich, nichts zu veröffentlichen. Hier lässt sich die letzte Veröffentlichung zurücknehmen.",
    "auf_live_zaehler": "{n} Änderung seit Live | {n} Änderungen seit Live",
    "mehr": "Was hier gerade nicht hinpasst"
  },
  "seite": {
    "entwurf": "Entwurf",
    "sichtbar": "Sichtbar",
    "entwurf_marke": "Entwurf, sichtbar machen",
    "sichtbar_marke": "Sichtbar, zurückstellen",
    "sichtbar_machen": "Sichtbar machen",
    "sichtbar_machen_hinweis": "Kommt mit dem nächsten „Auf Live“ auf die Website",
    "zurueck_entwurf": "Zurück auf Entwurf",
    "zurueck_entwurf_hinweis": "Verschwindet mit dem nächsten „Auf Live“ von der Website",
    "diese_seite": "Diese Seite",
    "gespeichert": "Gespeichert",
    "gespeichert_vor": "Gespeichert vor {min} min",
    "baue_vorschau": "Vorschau wird gebaut …",
    "sprache": "Sprache",
    "vorschau": "Vorschau",
    "vorschau_groesse": "Vorschau-Größe",
    "desktop": "Desktop",
    "tablet": "Tablet",
    "handy": "Handy",
    "desktop_hinweis": "So breit wie der Platz",
    "breite_hinweis": "{px} px breit",
    "desktop_titel": "Desktop, so breit wie der Platz",
    "tablet_titel": "Tablet, 768 px breit",
    "handy_titel": "Handy, 390 px breit",
    "neu_laden": "Vorschau neu laden",
    "kommentare": "Kommentar-Liste",
    "kommentare_offen": "Kommentar-Liste, {n} offen",
    "speichern": "Speichern",
    "speichere": "Wird gespeichert…",
    "speichern_titel": "{n} ungespeicherte Änderung, jetzt speichern (Cmd+S) | {n} ungespeicherte Änderungen, jetzt speichern (Cmd+S)",
    "panel_links": "Seiten und Felder ein- oder ausblenden",
    "panel_rechts": "Bearbeiten-Panel ein- oder ausblenden",
    "feld_bearbeiten": "Feld bearbeiten",
    "was": "Diese Seite",
    "fehler": {
      "ohne_ueberschrift": "Ohne Überschrift entsteht keine Seite.",
      "keine_adresse": "Aus dieser Überschrift lässt sich keine Adresse bilden. Bitte verwenden Sie Buchstaben oder Zahlen.",
      "sprache_gibt_es_schon": "Diese Seite gibt es auf {sprache} schon.",
      "sprache_unbekannt": "Diese Vorlage kennt die Sprache {sprache} nicht.",
      "seite_unbekannt": "Diese Seite steht nicht mehr im Verzeichnis. Bitte laden Sie neu.",
      "vorlage_unbekannt": "Dieses Projekt kennt diese Vorlage nicht.",
      "nur_entwurf": "Diese Seite steht auf der Website. Stellen Sie sie erst zurück auf Entwurf, dann lässt sie sich löschen."
    },
    "verlassen_frage": "Sie haben {n} ungespeicherte Änderung. Wirklich verlassen, ohne zu speichern? | Sie haben {n} ungespeicherte Änderungen. Wirklich verlassen, ohne zu speichern?",
    "loeschen_frage": "„{name}“ löschen?\n\nDie Seite verschwindet mit allen Texten und Sprachen. Rückgängig machen kann das nur miraTEQ.",
    "geloescht": "„{name}“ wurde gelöscht",
    "suche_aus": "Nicht in Suchmaschinen zeigen",
    "suche_aus_hinweis": "Bleibt auf der Website, Google und Co. nehmen sie nicht auf",
    "suche_an": "Wieder in Suchmaschinen zeigen",
    "suche_an_hinweis": "Google und Co. dürfen die Seite wieder aufnehmen",
    "ohne_suche_marke": "Nicht in Suchmaschinen",
    "uebersetzen": "Mit Claude übersetzen",
    "uebersetzen_hinweis": "Claude füllt alle weiteren Sprachen dieser Seite in der Vorschau",
    "landing_an": "Als Landingpage: Kopf ohne Menü",
    "landing_an_hinweis": "Für Werbe- und Angebotsseiten: Oben stehen nur Logo und Knopf, damit Besucher bei der einen Sache bleiben.",
    "landing_aus": "Wieder mit Menü im Kopf",
    "landing_aus_hinweis": "Die Seite zeigt oben wieder das Menü der Website.",
    "beitrag_an": "Als Beitrag mit Datum von heute",
    "beitrag_an_hinweis": "Die Seite erscheint mit Datum, Bild und Beschreibung im Abschnitt „Neuigkeiten“.",
    "beitrag_aus": "Kein Beitrag mehr",
    "beitrag_aus_hinweis": "Beitrag vom {datum}. Danach ist es wieder eine gewöhnliche Seite, ohne Datum und nicht mehr in den Neuigkeiten."
  },
  "liste": {
    "seiten": "Seiten",
    "felder": "Felder",
    "seiten_des_projekts": "Seiten des Projekts",
    "neuer": "Neuer {was}",
    "entwurf_punkt": "Entwurf, steht noch nicht auf der Website",
    "zeilenmenue": "Was mit „{name}“ geschehen soll",
    "loeschen": "{was} löschen",
    "loeschen_hinweis": "Endgültig, samt allen Texten",
    "seite": "Seite",
    "startseite": "Startseite",
    "alle_seiten": "Für alle Seiten",
    "weitere": "Weitere",
    "geteilt": "Geteilt",
    "geteilt_hinweis": "Texte, die auf mehreren Seiten stehen",
    "filtern": "Filtern …",
    "nichts_gefunden": "Nichts gefunden.",
    "anlegen": "Anlegen",
    "wird_angelegt": "Wird angelegt …",
    "abschnitte": "Abschnitte",
    "ungespeichert_punkt": "Ungespeicherte Änderungen"
  },
  "suche": {
    "titel": "Suchen und tun",
    "platzhalter": "Seite, Feld, Projekt oder Handgriff …",
    "nichts": "Nichts gefunden.",
    "auswaehlen": "auswählen",
    "ausfuehren": "ausführen",
    "gruppe_seiten": "Seiten",
    "gruppe_felder": "Felder dieser Seite",
    "gruppe_projekte": "Projekte",
    "gruppe_handgriffe": "Handgriffe",
    "vorschau_link_erstellen": "Vorschau-Link erstellen",
    "auf_live_veroeffentlichen": "Auf Live veröffentlichen",
    "aenderungen": "{n} Änderung | {n} Änderungen",
    "nichts_neues": "nichts Neues"
  },
  "konto": {
    "sprache": "Sprache der Oberfläche",
    "sprache_hinweis": "Gilt nur für das CMS, nicht für die Website",
    "deutsch": "Deutsch",
    "englisch": "English",
    "name": "Name",
    "hell": "Hell",
    "dunkel": "Dunkel",
    "modus_dunkel": "Dunkel-Modus (Klick: Hell)",
    "modus_hell": "Hell-Modus (Klick: Dunkel)",
    "passwort_verbergen": "Passwort verbergen",
    "passwort_anzeigen": "Passwort anzeigen",
    "verbergen": "🙈 Verbergen",
    "anzeigen": "👁 Anzeigen",
    "speichert": "Wird gespeichert …",
    "weiter": "Weiter",
    "kopiert": "✓ Kopiert",
    "kopieren": "Kopieren",
    "wird_aktiviert": "Wird aktiviert …",
    "zwei_fa_aktivieren": "2FA aktivieren",
    "wird_deaktiviert": "Wird deaktiviert …",
    "zwei_fa_deaktivieren": "2FA deaktivieren",
    "code_eingeben": "Bitte geben Sie den 6-stelligen Code ein.",
    "zwei_fa_an": "2FA ist aktiv. Beim nächsten Anmelden wird der Code abgefragt.",
    "zwei_fa_aus": "2FA deaktiviert",
    "kopieren_fehler": "Kopieren ging nicht. Bitte notieren Sie die Codes von Hand.",
    "codes_datei_titel": "miraCMS Recovery-Codes für {name}",
    "codes_datei_erstellt": "Erstellt: {datum}",
    "codes_datei_einmal": "Jeder Code ist nur EINMAL verwendbar. Nutzen Sie einen, wenn das Handy verloren geht.",
    "codes_datei_aufbewahren": "Sicher aufbewahren (Passwort-Manager oder ausgedruckt).",
    "passwort_geaendert": "Passwort geändert",
    "fehler": {
      "sitzung": "Die Sitzung ist abgelaufen. Bitte melden Sie sich ab und wieder an.",
      "passwort_falsch": "Das Passwort stimmt nicht.",
      "passwort_kurz": "Das neue Passwort braucht mindestens 15 Zeichen, mit Zwei-Faktor-Schutz 12.",
      "passwort_kurz_fremd": "Das neue Passwort braucht mindestens 15 Zeichen.",
      "erst_einrichten": "Bitte richten Sie 2FA zuerst ein."
    }
  },
  "menue": {
    "weitere": "Weitere Handgriffe"
  },
  "ui": {
    "hauptnavigation": "Hauptnavigation",
    "verlauf": "Verlauf",
    "lade_verlauf": "Verlauf wird geladen…",
    "keine_aenderungen_an_dieser_page_gefunden": "Keine Änderungen an dieser Page gefunden.",
    "neu_laden": "Neu laden",
    "lade_diff": "Vergleich wird geladen …",
    "keine_textlichen_aenderungen_in_dieser_datei": "Keine Änderungen am Text in dieser Datei (nur Metadaten geändert).",
    "aenderungsverlauf": "Änderungsverlauf",
    "schliessen": "Schließen",
    "konto_amp_sicherheit": "Konto & Sicherheit",
    "abmelden": "Abmelden",
    "fuer_dieses_konto_ist_zwei_faktor_schutz_erf": "Für dieses Konto ist Zwei-Faktor-Schutz erforderlich.",
    "jetzt_einrichten": "Jetzt einrichten",
    "menue_schliessen": "Menü schließen",
    "bereitgestellt_von": "Bereitgestellt von",
    "vorschau_wird_noch_gebaut": "Vorschau wird noch gebaut",
    "keine_eigene_seite": "Keine eigene Seite",
    "zurueck": "Zurück",
    "preview_nicht_verfuegbar": "Preview nicht verfügbar",
    "erneut_versuchen": "Erneut versuchen",
    "customer_site_live_preview": "Customer-Site Live-Preview",
    "uebersicht_ausblenden": "Übersicht ausblenden",
    "vorschau_im_zusammenhang": "Vorschau im Zusammenhang",
    "hoehe_der_uebersicht": "Höhe der Übersicht",
    "vorschau_link_erstellen": "Vorschau-Link erstellen",
    "keine_staging_url_konfiguriert": "(keine Staging-URL konfiguriert)",
    "magic_link_klick_zum_kopieren": "Magic-Link (zum Kopieren klicken)",
    "in_zwischenablage_kopiert_jetzt_in_whatsapp": "✓ In die Zwischenablage kopiert. Jetzt in WhatsApp, Mail oder anderswo einfügen.",
    "anderen_link_generieren": "← Anderen Link generieren",
    "customer_vorschau_link_generieren": "Customer-Vorschau-Link generieren",
    "benachrichtigungen": "Benachrichtigungen",
    "ansicht_wechseln": "Ansicht wechseln",
    "kachel_ansicht": "Kachel-Ansicht",
    "listen_ansicht": "Listen-Ansicht",
    "zugriff": "Zugriff",
    "zugaenge": "Zugänge",
    "anlegen": "+ Anlegen",
    "passwort": "Passwort",
    "entfernen": "Entfernen",
    "setzen": "Setzen",
    "abbrechen": "Abbrechen",
    "noch_kein_zugang": "Noch kein Zugang.",
    "anlegen_2": "Anlegen",
    "nur_jetzt_sichtbar": "Nur jetzt sichtbar.",
    "link_ohne_anmeldung": "Link ohne Anmeldung",
    "link_erzeugen": "Link erzeugen",
    "neuer_link": "Neuer Link",
    "einen_moment": "Einen Moment …",
    "zwei_faktor_schutz_ist_eingeschaltet": "Zwei-Faktor-Schutz ist eingeschaltet",
    "neues_passwort": "Neues Passwort",
    "benutzername": "Benutzername",
    "adresse_des_links": "Adresse des Links",
    "der_bisherige_link_gilt_danach_nicht_mehr": "Der bisherige Link gilt danach nicht mehr",
    "ansehen": "Ansehen",
    "durch_die_seite_klicken_wie_ein_besucher": "Durch die Seite klicken wie ein Besucher",
    "kommentieren": "Kommentieren",
    "kommentare_an_stellen_heften": "Kommentare an Stellen heften",
    "durch_die_seite_klicken": "Durch die Seite klicken",
    "texte_aendern": "Texte ändern",
    "selbst_am_text_arbeiten_und_speichern": "Selbst am Text arbeiten und speichern",
    "selbst_veroeffentlichen": "Selbst veröffentlichen",
    "auf_die_echte_website_stellen_ohne_uns": "Auf die echte Website stellen, ohne uns",
    "breite_des_feld_editors": "Breite des Feld-Editors",
    "alle_kommentare": "← Alle Kommentare",
    "die_stelle_gibt_es_auf_dieser_seite_nicht_me": "Die Stelle gibt es auf dieser Seite nicht mehr. Der Kommentar bleibt erhalten, aber er hat keine Nadel.",
    "der_kommentar_bleibt_offen_zum_abschliessen": "Der Kommentar bleibt offen. Zum Abschließen unten „Erledigt\".",
    "zustand": "Zustand",
    "sichtbar_fuer": "Sichtbar für",
    "erledigt": "Erledigt",
    "wieder_oeffnen": "Wieder öffnen",
    "loeschen": "Löschen",
    "bild_oder_pdf_anhaengen_geht_auch_mit_ziehen": "Bild oder PDF anhängen, geht auch mit Ziehen oder Einfügen",
    "antworten": "Antworten …",
    "alle": "Alle",
    "laedt": "Lädt …",
    "ohne_nadel": "ohne Nadel",
    "die_stelle_gibt_es_auf_dieser_seite_nicht_me_2": "Die Stelle gibt es auf dieser Seite nicht mehr",
    "klebt_auf_einer_anderen_seite_ein_klick_wech": "Klebt auf einer anderen Seite. Ein Klick wechselt dorthin.",
    "kommentar_an_dieser_stelle": "Kommentar an dieser Stelle",
    "eine_stelle_ohne_eigenen_text": "Eine Stelle ohne eigenen Text",
    "datei": "Datei",
    "art": "Art",
    "was_soll_hier_anders_werden": "Was soll hier anders werden?",
    "ueberschrift": "Überschrift",
    "sprache": "Sprache",
    "die_zweite_sprache_kann_spaeter_dazukommen": "Die zweite Sprache kann später dazukommen.",
    "adresse": "Adresse",
    "bleibt_so_auch_wenn_die_ueberschrift_sich_sp": "Bleibt so, auch wenn die Überschrift sich später ändert.",
    "startet_als_entwurf_auf_der_website_erschein": "Startet als Entwurf. Auf der Website erscheint er erst, wenn Sie ihn freigeben.",
    "was_ein_klick_in_die_vorschau_tut": "Was ein Klick in die Vorschau tut",
    "schritt": "Schritt",
    "diese_seite_hat_animationen_waehle_einen_sch": "Diese Seite hat Animationen. Wählen Sie einen Schritt, um den Text zu sehen und zu bearbeiten, der dort erscheint.",
    "waehle_links_ein_feld_zum_editieren": "Wählen Sie links ein Feld zum Bearbeiten.",
    "dieser_text_wird_geteilt_und_erscheint_auf_m": "Dieser Text wird geteilt und erscheint auf mehreren Seiten. Die Änderung wirkt überall.",
    "auch_hier": "Auch hier",
    "andere_sprachen": "Andere Sprachen",
    "zuruecksetzen": "Zurücksetzen",
    "ungespeicherte_aenderung": "ungespeicherte Änderung",
    "noch_offen": "Noch offen",
    "gepinnt": "Gepinnt",
    "erscheint_auf_mehreren_seiten": "(erscheint auf mehreren Seiten)",
    "keine_felder_gefunden": "Keine Felder gefunden.",
    "speichern": "speichern…",
    "gespeichert": "gespeichert",
    "felder_filtern": "Felder filtern…",
    "felder_filtern_2": "Felder filtern",
    "account": "Account",
    "username": "Username",
    "rolle": "Rolle",
    "projekte": "Projekte",
    "darstellung": "Darstellung",
    "theme": "Theme",
    "passwort_aendern": "Passwort ändern",
    "aktuelles_passwort": "Aktuelles Passwort",
    "neues_passwort_min_8_zeichen": "Neues Passwort (mindestens 15 Zeichen, mit Zwei-Faktor-Schutz 12)",
    "wiederholen_zur_sicherheit": "Wiederholen (zur Sicherheit)",
    "passwoerter_stimmen_nicht_ueberein": "Passwörter stimmen nicht überein",
    "zwei_faktor_authentifizierung_2fa": "Zwei-Faktor-Authentifizierung (2FA)",
    "2fa_ist_aktiviert": "2FA ist aktiviert",
    "beim_login_fragt_miracms_einen_6_stelligen_c": "Beim Login fragt miraCMS einen 6-stelligen Code aus Ihrer Authenticator-App ab.",
    "deaktivieren": "Deaktivieren",
    "2fa_ist_nicht_aktiv": "2FA ist nicht aktiv",
    "empfohlen_schuetzt_deinen_account_auch_wenn": "Empfohlen: schützt Ihren Account, auch wenn das Passwort durchsickert.",
    "einrichten": "Einrichten",
    "bestaetige_dein_aktuelles_passwort_dann_zeig": "Bestätigen Sie Ihr aktuelles Passwort, dann zeigt miraCMS den QR-Code für Ihre Authenticator-App.",
    "schritt_1": "Schritt 1:",
    "app_kann_nicht_scannen_tippe_das_secret_manu": "App kann nicht scannen? Tippen Sie das Secret von Hand ein:",
    "schritt_2": "Schritt 2:",
    "als_txt_herunterladen": "Als .txt herunterladen",
    "schritt_3": "Schritt 3:",
    "bestaetige_den_ersten_code_aus_der_app": "Bestätigen Sie den ersten Code aus der App.",
    "6_stelliger_code_aus_app": "6-stelliger Code aus App",
    "2fa_wird_deaktiviert_dein_account_ist_dann_n": "2FA wird deaktiviert. Ihr Account ist dann nur noch durch das Passwort geschützt. Bestätigen Sie Ihr Passwort.",
    "sitzung": "Sitzung",
    "aktuelle_sitzung_beenden_und_zum_login_wechs": "Aktuelle Sitzung beenden und zum Login wechseln.",
    "2fa_qr_code": "2FA QR-Code",
    "vorschau_seite": "Vorschau-Seite",
    "wird_geladen": "Wird geladen …",
    "ansehen_2": "Ansehen ↗",
    "geaendert": "geändert",
    "zuruecksetzen_2": "zurücksetzen",
    "auf_allen_vier_seiten": "Auf allen vier Seiten",
    "alles_auf_standard_ein_leeres_feld_setzt_zur": "Alles auf Standard. Ein leeres Feld setzt zurück.",
    "der_haeufigste_fall_jemand_ruft_die_adresse": "Der häufigste Fall: jemand ruft die Adresse ohne den persönlichen Link auf.",
    "der_link_war_einmal_gueltig_ist_es_nach_30_t": "Der Link war einmal gültig, ist es nach 30 Tagen aber nicht mehr.",
    "seltener_fehlerfall_auf_dem_server_sollte_ni": "Seltener Fehlerfall auf dem Server. Sollte niemand zu sehen bekommen.",
    "der_link_zeigt_auf_eine_unterseite_die_es_ni": "Der Link zeigt auf eine Unterseite, die es nicht gibt.",
    "kleintext_unten": "Kleintext unten",
    "steht_unter_der_karte_auf_jeder_der_vier_sei": "Steht unter der Karte, auf jeder der vier Seiten.",
    "betreff_der_mail": "Betreff der Mail",
    "die_adresse_der_vorschau_wird_hinten_angehae": "Die Adresse der Vorschau wird hinten angehängt.",
    "kundenzugaenge": "Kundenzugänge",
    "name_display": "Name (display)",
    "passwort_neuer_benutzer": "Passwort (mindestens 15 Zeichen)",
    "admin_alle_projekte_user_verwaltung": "admin (alle Projekte + User-Verwaltung)",
    "editor_alle_projekte_keine_user_verwaltung": "editor (alle Projekte, keine User-Verwaltung)",
    "lade_benutzer": "Benutzer werden geladen …",
    "alle_projekte": "· alle Projekte",
    "kein_projekt_zugewiesen": "· kein Projekt zugewiesen",
    "bearbeiten": "Bearbeiten",
    "sieht_automatisch_alle_projekte_keine_auswah": "Sieht automatisch alle Projekte, keine Auswahl nötig.",
    "keine_projekte_konfiguriert": "Keine Projekte konfiguriert.",
    "passwort_zuruecksetzen": "Passwort zurücksetzen",
    "ersetzen": "Ersetzen",
    "laedt_hoch": "Lädt hoch …",
    "wird_auf_cdn_mirateq_com_gespeichert": "Wird auf cdn.mirateq.com gespeichert",
    "bild_ersetzen": "Bild ersetzen",
    "jpg_png_gif_oder_webp_wird_automatisch_optim": "JPG, PNG, GIF oder WebP, wird automatisch optimiert",
    "link_weg": "Link weg",
    "fett_b": "Fett (⌘B)",
    "kursiv_i": "Kursiv (⌘I)",
    "ausgewaehlten_text_zu_einem_link_machen": "Ausgewählten Text zu einem Link machen",
    "link_entfernen": "Link entfernen",
    "liste": "• Liste",
    "1_liste": "1. Liste",
    "umbruch": "↵ Umbruch",
    "ohne_format_einfuegen": "Ohne Format einfügen",
    "zwischenueberschrift": "Zwischenüberschrift",
    "aufzaehlung_mit_punkten": "Aufzählung mit Punkten",
    "aufzaehlung_mit_zahlen": "Aufzählung mit Zahlen",
    "zeilenumbruch_an_der_cursorstelle": "Zeilenumbruch an der Cursorstelle",
    "aus_der_zwischenablage_einfuegen_ohne_format": "Aus der Zwischenablage einfügen, ohne Formatierung",
    "bitte_waehlen": "Bitte wählen …",
    "zurueck_2": "← Zurück",
    "projekt": "← Projekt",
    "veroeffentlicht": "Wird veröffentlicht …",
    "website_aktuell": "Website aktuell",
    "veroeffentlichen": "Veröffentlichen",
    "neuer_eintrag": "+ Neuer Eintrag",
    "speichert": "Speichert …",
    "suche_aktiv_sortieren_pausiert": "Suche aktiv, Sortieren pausiert.",
    "noch_nicht_veroeffentlicht": "Noch nicht veröffentlicht",
    "hier_bleiben": "Hier bleiben",
    "spaeter_veroeffentlichen": "Später veröffentlichen",
    "jetzt_veroeffentlichen_amp_gehen": "Jetzt veröffentlichen & gehen",
    "diesen_eintrag_wirklich_loeschen": "Diesen Eintrag wirklich löschen?",
    "suchen": "Suchen …",
    "liste_2": "Liste",
    "kacheln": "Kacheln",
    "ziehen_zum_sortieren": "Ziehen zum Sortieren",
    "ziehen": "Ziehen",
    "umbenennen": "Umbenennen",
    "ihre_kommentare_zur_website": "Ihre Kommentare zur Website",
    "bitte_melden_sie_sich_bei_uns_dann_schicken": "Bitte melden Sie sich bei uns, dann schicken wir Ihnen einen neuen.",
    "klicken_sie_auf_eine_stelle_in_der_seite_um": "Klicken Sie auf eine Stelle in der Seite, um einen Kommentar zu hinterlassen.",
    "sie_sehen_die_seite_wie_ein_besucher_zum_anm": "Sie sehen die Seite wie ein Besucher. Zum Anmerken oben auf die Sprechblase.",
    "ihre_kommentare": "Ihre Kommentare",
    "zwei_faktor_code": "Zwei-Faktor-Code",
    "oeffne_deine_authenticator_app_und_tippe_den": "Öffnen Sie Ihre Authenticator-App und tippen Sie den 6-stelligen Code ein.",
    "code": "Code",
    "z_b_admin": "z.B. admin",
    "seite_nicht_gefunden": "Seite nicht gefunden",
    "vorschau_link": "Vorschau-Link",
    "auf_live_veroeffentlichen": "Auf Live veröffentlichen",
    "design_farben": "Design · Farben",
    "projekt_laedt": "Projekt lädt…",
    "live_preview": "Live-Preview",
    "einstellungen": "Einstellungen",
    "account_amp_benutzer_verwaltung": "Account & Benutzer-Verwaltung",
    "benutzer": "Benutzer",
    "lesbarkeit_wcag_kontrast": "Lesbarkeit (WCAG-Kontrast)",
    "ziel_aa_4_5_fuer_normalen_text_hinweis_kein": "Ziel: AA (≥ 4.5) für normalen Text. Hinweis, kein Zwang.",
    "live_vorschau": "Live-Vorschau",
    "auf_gespeicherten_wert_zuruecksetzen": "Auf gespeicherten Wert zurücksetzen",
    "live_vorschau_farben": "Live-Vorschau Farben",
    "diese_seite_ist_gerade_nicht_als_vorschau_vo": "Diese Seite ist gerade nicht als Vorschau vorhanden. Nach dem nächsten Speichern baut der Server sie neu, das dauert einen Moment. Bearbeiten können Sie die Texte in der Feldliste sofort.",
    "diese_texte_erscheinen_auf_mehreren_seiten_z": "Diese Texte erscheinen auf mehreren Seiten (z. B. Preise, Navigation oder Footer). Sie können sie rechts in der Feldliste ganz normal bearbeiten, sie werden überall dort aktualisiert, wo sie vorkommen.",
    "link_generieren_kopieren_und_per_whatsapp_si": "Link generieren, kopieren und per WhatsApp / Signal / Line / Mail an den Kunden weiterleiten. Gültig 30 Tage (Cookie-Lifetime).",
    "per_whatsapp_signal_line_mail_an_den_kunden": "Per WhatsApp / Signal / Line / Mail an den Kunden senden. Beim Klick setzt der Link einen 30-Tage-Cookie und der Kunde kann sich die Vorschau ansehen.",
    "scanne_diesen_qr_code_mit_deiner_authenticat": "Scannen Sie diesen QR-Code mit Ihrer Authenticator-App (z. B. Google Authenticator, 1Password, Authy, iCloud-Schlüsselbund).",
    "sichere_diese_recovery_codes_sie_helfen_wenn": "Bewahren Sie diese Recovery-Codes sicher auf. Sie helfen, wenn das Handy verloren geht. Jeder Code ist nur EINMAL verwendbar.",
    "diese_seite_sieht_eine_kundin_wenn_sie_eine": "Diese Seite sieht eine Kundin, wenn sie eine Vorschau ohne gültigen Link öffnet. Sie erscheint automatisch in der Sprache der jeweiligen Website. Eine Änderung hier wirkt sofort auf allen Vorschau-Adressen, ohne Deploy.",
    "sieht_automatisch_alle_projekte_keine_auswah_2": "Sieht automatisch alle Projekte, keine Auswahl nötig. Ein Zugang für einen Kunden entsteht im Projekt unter „Zugriff“.",
    "link_unvollstaendig": "Der Link ist unvollständig.",
    "link_gilt_nicht_mehr": "Dieser Link gilt nicht mehr.",
    "zu_viele_versuche": "Zu viele Versuche von hier aus. Bitte in einer Viertelstunde noch einmal.",
    "gleich_wieder_da": "Bitte laden Sie die Seite dann neu.",
    "original": "Original",
    "auf_die_ausgelieferte_markenfarbe_zuruecksetzen": "Auf die ausgelieferte Markenfarbe zurücksetzen",
    "alle_auf_original": "Alle auf Original",
    "alle_farben_auf_die_ausgelieferten_werte": "Alle Farben auf die ausgelieferten Markenwerte zurücksetzen",
    "nur_ansehen": "Nur ansehen: Für diesen Zugang ist das Ändern von Texten nicht freigeschaltet.",
    "katalog_pflegen": "Katalog pflegen",
    "katalog_pflegen_hinweis": "Einträge im Katalog anlegen, ändern und veröffentlichen"
  },
  "meldung": {
    "ansehen": "Ansehen",
    "ansehen_hinweis": "Durch die Seite klicken wie im Browser",
    "kommentieren": "Kommentieren",
    "kommentieren_hinweis": "Kommentar an eine Stelle heften",
    "bearbeiten": "Bearbeiten",
    "bearbeiten_hinweis": "Text anklicken und ändern",
    "speichern_abgelehnt": "Speichern abgelehnt",
    "unbekannter_fehler": "Unbekannter Fehler",
    "nicht_in_versionsgeschichte": "Die Änderung liegt auf dem Server, wurde aber nicht in die Versionsgeschichte aufgenommen.",
    "erst_speichern": "Erst speichern",
    "ungespeicherte_auf_dieser_seite": "Es gibt ungespeicherte Änderungen auf dieser Seite.",
    "hier_nicht_moeglich": "Das ist hier nicht möglich.",
    "kommentar_weg": "Diesen Kommentar gibt es nicht mehr.",
    "sitzung_abgelaufen": "Die Sitzung ist abgelaufen. Bitte die Seite neu laden.",
    "server_stumm": "Der Server hat nicht geantwortet. Bitte noch einmal versuchen.",
    "nicht_geklappt": "Das hat nicht geklappt. Bitte noch einmal versuchen.",
    "eingabe_abgelehnt": "Die Eingabe hat der Server nicht angenommen.",
    "server_abgebrochen": "Der Server hat abgebrochen: {dazu}",
    "gibt_es_nicht_mehr": "{was} ist nicht mehr vorhanden.",
    "zu_viele_kommentare": "Zu viele Kommentare in kurzer Zeit. In {minuten} Minuten geht es weiter.",
    "zu_viele_kommentare_gleich": "Zu viele Kommentare in kurzer Zeit. Gleich geht es weiter.",
    "zu_viele_kommentare_eine": "Zu viele Kommentare in kurzer Zeit. In einer Minute geht es weiter.",
    "nicht_gespeichert": "Nicht gespeichert",
    "kein_bearbeiten_recht": "Für diesen Zugang ist das Ändern von Texten nicht freigeschaltet.",
    "was_das": "Das",
    "keine_berechtigung": "Dafür fehlt die Berechtigung.",
    "inzwischen_geaendert": "{was} hat sich inzwischen geändert. Bitte laden Sie neu.",
    "zu_viele_aenderungen": "Gerade kamen sehr viele Änderungen kurz hintereinander. Bitte warten Sie eine Minute und versuchen Sie es dann noch einmal.",
    "ging_nicht": "Ging nicht",
    "keine_texte": "Keine Texte gefunden",
    "bereich_kaputt": "Ein Textbereich ist beschädigt: {name}",
    "bereiche_kaputt": "{n} Textbereich ist beschädigt | {n} Textbereiche sind beschädigt",
    "bereich_kaputt_text": "Alles andere lässt sich normal bearbeiten. Bitte geben Sie miraTEQ Bescheid.",
    "nicht_bei_github": "Die Änderung liegt auf dem Server, ist aber noch nicht bei GitHub.",
    "gespeichert_ungesichert": "Gespeichert, aber nicht gesichert",
    "absatz": {
      "eingefuegt": "Absatz eingefügt",
      "hoch": "Absatz nach oben",
      "runter": "Absatz nach unten",
      "geloescht": "Absatz gelöscht",
      "geaendert": "Geändert"
    },
    "vorschau_aktuell": "Die Vorschau ist aktualisiert.",
    "vorschau_nicht_aktuell": "Vorschau noch nicht aktuell",
    "anderer_bau": "Es läuft gerade ein anderer Bau. Bitte laden Sie in einem Moment neu.",
    "text_bricht_vorschau": "Dieser Text bricht die Vorschau",
    "vorschau_bau_fehler": "Vorschau konnte nicht neu gebaut werden",
    "vorschau_anstossen_fehler": "Die Vorschau ließ sich nicht neu bauen lassen",
    "vorschau_dauert": "Vorschau dauert ungewöhnlich lange",
    "vorschau_dauert_text": "Der Text ist gespeichert. Die Vorschau wird noch gebaut.",
    "pruefung": {
      "titel": "Eingabe ungültig",
      "mehrere": "Mehrere Felder sind ungültig.",
      "zu_lang": "Höchstens {max} Zeichen erlaubt (eingegeben: {laenge}).",
      "zu_lang_kurz": "Text zu lang.",
      "zu_kurz": "Mindestens {min} Zeichen erforderlich (eingegeben: {laenge}).",
      "zu_kurz_kurz": "Text zu kurz.",
      "pflicht": "Pflichtfeld, darf nicht leer sein.",
      "farbe": "Bitte einen Farbcode im Format #RRGGBB eingeben (z. B. #32542f).",
      "format": "Format ungültig.",
      "url": "Bitte eine vollständige Adresse eingeben (z. B. https://example.com).",
      "email": "Bitte eine gültige E-Mail-Adresse eingeben.",
      "datum": "Bitte ein gültiges Datum eingeben (Format: JJJJ-MM-TT).",
      "typ_text": "Hier wird Text erwartet.",
      "typ_zahl": "Hier wird eine Zahl erwartet.",
      "typ_ja_nein": "Hier wird Ja oder Nein erwartet.",
      "typ": "Falscher Werttyp.",
      "unbekannt": "Dieses Feld ist im Schema nicht vorgesehen.",
      "auswahl": "Ungültiger Wert, erlaubt sind: {erlaubt}",
      "auswahl_kurz": "Ungültiger Wert."
    }
  },
  "datei": {
    "loeschen": "Endgültig löschen",
    "wirklich": "Wirklich löschen?",
    "ja_loeschen": "Ja, löschen",
    "geloescht": "Datei gelöscht",
    "nur_pdf": "Bitte eine PDF-Datei wählen.",
    "hochgeladen": "PDF hochgeladen",
    "hochgeladen_mit_vorschau": "PDF hochgeladen und Vorschau erstellt",
    "ziehen": "PDF hierher ziehen oder tippen zum Auswählen",
    "noch_in_gebrauch": "Die Datei steht noch an anderer Stelle im Projekt.",
    "geloescht_cache_bleibt": "Datei gelöscht. Die Kopie im Netz-Zwischenspeicher verschwindet von allein.",
    "nur_bild": "Bitte eine Bilddatei wählen (JPG, PNG, GIF, WebP).",
    "bild_hochgeladen": "Bild hochgeladen ({kb} KB)",
    "bild_nicht_gesichert": "Bild hochgeladen, aber nicht gesichert",
    "bild_nicht_gesichert_text": "Es liegt auf dem Server, ist aber noch nicht bei GitHub. Bitte geben Sie miraTEQ Bescheid, bevor Sie veröffentlichen.",
    "bild_hochladen_fuer": "Bild hochladen für {feld}",
    "bild_vorschau": "Vorschau {feld}",
    "bild_ziehen": "Bild hierher ziehen oder tippen zum Auswählen",
    "pdf_hochladen_fuer": "PDF hochladen für {feld}",
    "was": "Die Datei",
    "fehler": {
      "kein_bild": "Erlaubt sind nur JPG, PNG, GIF oder WebP.",
      "zu_gross": "Die Datei ist zu groß. Erlaubt sind bis zu {mb} MB.",
      "zu_gross_kurz": "Die Datei ist zu groß.",
      "abgebrochen": "Das Hochladen wurde unterbrochen. Bitte versuchen Sie es noch einmal.",
      "nicht_eingerichtet": "Das Hochladen von PDFs ist auf diesem Server noch nicht eingerichtet. Bitte geben Sie miraTEQ Bescheid.",
      "verarbeitung": "Das Bild ließ sich nicht verarbeiten. Bitte versuchen Sie es mit einer anderen Datei.",
      "speicher": "Die Datei ist nicht im Speicher angekommen. Bitte versuchen Sie es noch einmal.",
      "kein_dokument": "Diese Adresse gehört nicht zu unserem Dokumenten-Speicher.",
      "fremdes_dokument": "Diese Datei gehört zu einem anderen Projekt.",
      "loeschen": "Die Datei ließ sich nicht löschen. Bitte versuchen Sie es noch einmal."
    }
  },
  "kommentar": {
    "adressat": {
      "intern": "Nur uns",
      "kunde": "Auch der Kunde"
    },
    "typ": {
      "text_fix": "Text ändern",
      "design": "Gestaltung",
      "claude_task": "Technische Änderung"
    },
    "status": {
      "offen": "Offen",
      "in_arbeit": "In Arbeit",
      "erledigt": "Erledigt"
    },
    "screenshot_einfuegen": "Screenshot mit Cmd+V einfügen",
    "anheften": "Kommentar anheften",
    "nadel_kunde": "Kunde {n}, dieselbe Nadel wie in der Vorschau",
    "nadel": "Nadel {n} in der Vorschau",
    "sendet": "Wird gesendet …",
    "antworten": "Antworten",
    "gruppe_kunde": "Mit dem Kunden",
    "gruppe_intern": "Nur intern",
    "leer": "Noch keine Kommentare. Klicken Sie im Kommentieren-Modus in die Vorschau, um einen anzuheften.",
    "kein_treffer": "Kein Kommentar passt zu diesem Filter.",
    "antworten_anzahl": "{n} Antwort | {n} Antworten",
    "auf_seite": "auf {seite}",
    "klick_schliessen": "Klick zum Schließen",
    "offen_anzahl": "{n} offener Kommentar | {n} offene Kommentare",
    "ihre_website": "Ihre Website"
  },
  "feld": {
    "bild_alle_sprachen": "Das Bild gilt für alle Sprachen der Seite. Die Bildbeschreibung ist je Sprache.",
    "art": {
      "text": "Text",
      "bild": "Bild",
      "alt": "Bildbeschreibung",
      "href": "Linkziel",
      "src": "Bildquelle",
      "title": "Titel beim Überfahren",
      "placeholder": "Platzhalter im Feld",
      "content": "Meta-Angabe",
      "aria_label": "Beschriftung für Screenreader",
      "data_title": "Titel"
    },
    "absatz": {
      "hoch": "↑ nach oben",
      "hoch_titel": "Diesen Absatz nach oben schieben",
      "runter": "↓ nach unten",
      "runter_titel": "Diesen Absatz nach unten schieben",
      "danach": "+ Absatz darunter",
      "danach_titel": "Einen neuen Absatz darunter einfügen",
      "loeschen": "× löschen",
      "loeschen_titel": "Diesen Absatz löschen",
      "loeschen_frage": "Diesen Absatz löschen?\n\n„{text}“",
      "neu": "Neuer Absatz"
    },
    "uebersicht_ausblenden": "Übersicht ausblenden",
    "ansehen_auf": "Ansehen auf: {seite}",
    "max_zeichen": "max. {n} Zeichen",
    "gruppe_sonstige": "Sonstige",
    "gruppe_alle": "Alle Felder",
    "pin_entfernen_fuer": "Pin entfernen für {feld}",
    "pin_umschalten_fuer": "Pin umschalten für {feld}",
    "pin_entfernen": "Pin entfernen",
    "pin_setzen": "Feld anpinnen",
    "geteilte_gruppe": "Diese Texte erscheinen auf mehreren Seiten. Änderungen wirken überall.",
    "anzahl": "{n} Feld | {n} Felder",
    "ungespeichert_anzahl": "{n} ungespeichert",
    "ja": "Ja",
    "nein": "Nein",
    "farbwaehler_fuer": "Farbwähler für {feld}",
    "schritt_waehlen": "Schritt wählen: {szene}",
    "link": "Link",
    "link_erst_auswaehlen": "Bitte erst den Text auswählen, der zum Link werden soll.",
    "link_ziel_frage": "Wohin soll der Link führen?",
    "link_adresse": "Adresse des Links",
    "inhalt_bereinigt": "Teile des alten Inhalts waren nicht erlaubt und wurden entfernt.",
    "zwischenablage_gesperrt": "Der Browser gibt die Zwischenablage nicht frei. ⇧⌘V fügt ebenfalls ohne Formatierung ein.",
    "spiegel": {
      "zu_schmal": "Für die Umbrüche dieser Stelle ist das Feld zu schmal. Ziehen Sie es breiter (rund {px} Pixel), oder stellen Sie die Vorschau auf Handy.",
      "ungefaehr": "Die Umbrüche stimmen hier nur ungefähr mit der Seite überein.",
      "an_titel": "Das Feld bricht wie die Seite um. Klick: aus.",
      "aus_titel": "Feld so setzen, wie die Seite umbricht",
      "genau": "bricht wie die Seite",
      "ungefaehr_kurz": "≈ ungefähr wie die Seite",
      "aus": "wie die Seite"
    },
    "umbruch": {
      "ausgleich": "Die Seite verteilt die Zeilen dieser Überschrift gleichmäßig. Im Feld steht der Umbruch nur ungefähr an derselben Stelle.",
      "geschwister": "Neben diesem Text steht im selben Absatz noch etwas anderes. Die letzte Zeile ist auf der Seite deshalb kürzer.",
      "inline_kinder": "In diesem Text stecken Auszeichnungen. Das Feld zeigt ihn in einem Schnitt, die Seite in mehreren.",
      "lokal": "Die Seite darf eine auf dem Rechner installierte Schrift benutzen. Dann können die Umbrüche leicht abweichen.",
      "schrift_fehlt": "Die Schrift der Seite ließ sich nicht laden. Die Umbrüche sind deshalb nur ungefähr.",
      "erste_zeile": "Die erste Zeile ist auf der Seite anders gesetzt als der Rest.",
      "schrumpfbox": "Dieser Kasten wächst mit dem Text mit. Nach dem Speichern kann der Umbruch anders liegen.",
      "faltet_umbrueche": "Die Seite zeigt Zeilenumbrüche aus diesem Feld nicht als Umbruch.",
      "grossschrift": "Die Seite zeigt diesen Text in GROSSBUCHSTABEN."
    },
    "speichern_mit": "Speichern mit {taste} oder dem Speichern-Button oben rechts.",
    "textfarbe": "Textfarbe",
    "farbe_ohne": "Farbe: normal",
    "farbe_marke": "Markenfarbe",
    "farbe_akzent": "Akzentfarbe",
    "farbe_gedaempft": "Gedämpft",
    "textgroesse": "Textgröße",
    "groesse_normal": "Größe: normal",
    "groesse_gross": "Größer",
    "groesse_klein": "Kleiner",
    "hervorheben": "Markieren",
    "fokus_titel": "Bildausschnitt",
    "fokus_hinweis": "Dieser Teil bleibt sichtbar, wenn das Bild auf dem Handy oder als breiter Streifen beschnitten wird.",
    "fokus": {
      "oben-links": "Oben links",
      "oben": "Oben",
      "oben-rechts": "Oben rechts",
      "links": "Links",
      "mitte": "Mitte",
      "rechts": "Rechts",
      "unten-links": "Unten links",
      "unten": "Unten",
      "unten-rechts": "Unten rechts"
    }
  },
  "katalog": {
    "kategorie": "Kategorie",
    "eintraege": "Einträge",
    "sammlung": "Sammlung",
    "anzahl": "{n} Eintrag | {n} Einträge",
    "alle": "Alle {name}",
    "ohne": "Ohne {name}",
    "bearbeiten": "Bearbeiten",
    "fertig": "Fertig",
    "bearbeiten_beenden": "Bearbeiten beenden",
    "gruppe_bearbeiten": "{name} anlegen, umbenennen, sortieren, Bild ändern",
    "bild_aendern": "Bild ändern",
    "bild_hochladen": "Bild hochladen",
    "ok": "OK",
    "loeschen_frage": "„{name}“ löschen?",
    "umhaengen_auf": "{n} Eintrag umhängen auf: | {n} Einträge umhängen auf:",
    "hinzufuegen": "{name} hinzufügen …",
    "ziehen_hinweis": "Produkt links auf {name} ziehen = umhängen",
    "ziehen_titel": "Ziehen: sortieren oder auf {name} links",
    "keine_eintraege": "Keine Einträge.",
    "keine_treffer": "Keine Einträge für diese Suche.",
    "verlassen_text": "Ihre Änderungen sind {gespeichert}, aber noch nicht auf der Website. Möchten Sie sie jetzt veröffentlichen?",
    "eintrag_bearbeiten": "Eintrag bearbeiten",
    "neuer_eintrag": "Neuer Eintrag",
    "speichern": "Speichern",
    "eintrag_angelegt": "Eintrag angelegt",
    "gespeichert": "Gespeichert",
    "geloescht": "Gelöscht",
    "reihenfolge_gespeichert": "Reihenfolge gespeichert",
    "kategorie_angelegt": "Kategorie angelegt",
    "umbenannt": "Umbenannt",
    "umbenannt_mit": "Umbenannt, {n} Eintrag angepasst | Umbenannt, {n} Einträge angepasst",
    "kategorie_geloescht": "Kategorie gelöscht",
    "geloescht_umgehaengt": "Gelöscht, {n} Eintrag umgehängt | Gelöscht, {n} Einträge umgehängt",
    "bild_gesetzt": "Bild gesetzt",
    "bild_entfernt": "Bild entfernt",
    "alles_aktuell": "Alles aktuell",
    "veroeffentlicht_live": "Veröffentlicht. Die Website wird jetzt aktualisiert.",
    "veroeffentlicht_vorschau": "In der Vorschau veröffentlicht. Die öffentliche Website bleibt unverändert.",
    "was": "Dieser Eintrag",
    "was_kategorie": "Diese Kategorie",
    "fehler": {
      "anlegen": "Anlegen fehlgeschlagen",
      "loeschen": "Löschen fehlgeschlagen",
      "sortieren": "Sortieren fehlgeschlagen",
      "umbenennen": "Umbenennen fehlgeschlagen",
      "bild": "Bild-Upload fehlgeschlagen",
      "bild_entfernen": "Entfernen fehlgeschlagen",
      "veroeffentlichen": "Veröffentlichen fehlgeschlagen",
      "gibt_es_schon": "„{wert}“ gibt es schon.",
      "umhaengen_noetig": "Es hängen noch Einträge daran. Bitte wählen Sie, wohin sie umziehen."
    },
    "feld": {
      "unbekannt": "Dieses Feld gibt es in diesem Formular nicht.",
      "pflicht": "Pflichtfeld",
      "ganze_zahl": "Bitte eine ganze Zahl eingeben.",
      "zahl": "Bitte eine Zahl eingeben.",
      "ja_nein": "Bitte Ja oder Nein wählen.",
      "text": "Bitte einen Text eingeben.",
      "auswahl": "Bitte einen der vorgegebenen Werte wählen: {erlaubt}",
      "zu_kurz": "Mindestens {min} Zeichen.",
      "zu_lang": "Höchstens {max} Zeichen, aktuell {laenge}.",
      "zu_klein": "Der Wert muss mindestens {min} sein.",
      "zu_gross": "Der Wert darf höchstens {max} sein."
    },
    "was_sammlung": "Diese Sammlung"
  },
  "vorschau": {
    "keine_eigenen_texte": "Diese Seite hat keine eigenen Texte im CMS. Bearbeiten können Sie weiter {seite}.",
    "texte_ohne_seite": "Diese Texte haben keine eigene Seite. Gezeigt wird {seite}, dort kommen sie vor. Wählen Sie {links} ein Feld: Die Vorschau springt dann zur Stelle und markiert sie blau.",
    "links": "links",
    "so_sieht_es_aus": "So sieht es auf {seite} aus"
  },
  "verlauf": {
    "diff_fehler": "Vergleich ließ sich nicht laden",
    "wiederherstellen_frage": "Diesen Stand wiederherstellen (Commit {commit})?\n\nEs entsteht ein neuer Commit „restore“. Die aktuelle Version bleibt im Verlauf erhalten, Sie können sie jederzeit zurückholen.",
    "nichts_zu_tun": "Nichts zu tun, der Stand ist schon derselbe.",
    "wiederhergestellt": "Wiederhergestellt",
    "wiederhergestellt_text": "Neuer Commit angelegt. Staging wird neu gebaut.",
    "wiederherstellen_fehler": "Wiederherstellen fehlgeschlagen",
    "laden": "↻ Laden",
    "ohne_git": "Dieses Projekt wird nicht mit Git verfolgt (kein {ordner}-Verzeichnis).",
    "diff_auf": "Vergleich anzeigen",
    "diff_zu": "Vergleich einklappen",
    "neu": "+ (neu)",
    "entfernt": "− (entfernt)",
    "leer": "(leer)",
    "stellt_wieder_her": "Wird wiederhergestellt …",
    "zuruecksetzen": "↶ Auf diesen Stand zurücksetzen"
  },
  "banner": {
    "staging": "{umgebung}: Änderungen hier wirken nicht auf die Live-Site (cms.mirateq.com)"
  },
  "vorschaulink": {
    "fehler": "Der Link ließ sich nicht erzeugen.",
    "fehler_no_staging_url": "Für diese Website ist keine Vorschau-Adresse eingetragen.",
    "fehler_no_staging_token": "Für diese Vorschau fehlt der Schlüssel auf dem Server. Bitte geben Sie miraTEQ Bescheid.",
    "fehler_unknown_site": "Diesen Teil der Website gibt es im Projekt nicht.",
    "fehler_mehrere_sites": "Diese Website besteht aus mehreren Teilen. Dafür gibt es den Vorschau-Link noch nicht.",
    "fehler_cloudflare_unvollstaendig": "Die Website ist bei Cloudflare noch nicht fertig eingerichtet. Bitte geben Sie miraTEQ Bescheid.",
    "fehler_schluessel_nicht_angelegt": "Der Schlüssel für die Vorschau ließ sich nicht anlegen. Bitte versuchen Sie es gleich noch einmal.",
    "im_browser": "Vorschau im Browser",
    "kopieren_fehler": "Kopieren in die Zwischenablage ging nicht",
    "erzeugt": "Wird erzeugt …",
    "erzeugen": "Vorschau-Link erzeugen",
    "kopiert": "Kopiert!",
    "kopieren": "In die Zwischenablage kopieren"
  },
  "benutzer": {
    "einleitung": "Hier steht das eigene Team, Admins und Redaktion. Sie sehen alle Projekte. {kundenzugaenge} legen Sie im jeweiligen Projekt unter {zugriff} an, zusammen mit Passwort, Rechten und Link.",
    "derzeit": "Derzeit gibt es {n}. | Derzeit gibt es {n}.",
    "im_team": "{n} im Team",
    "neu": "+ Neuer Benutzer",
    "anlegen": "Benutzer anlegen",
    "ohne_projekt": "Ein Kundenzugang ohne Projekt steht mit in der Liste. Ordnen Sie ihn zu oder löschen Sie ihn, sonst findet ihn niemand mehr. | {n} Kundenzugänge ohne Projekt stehen mit in der Liste. Ordnen Sie sie zu oder löschen Sie sie, sonst findet sie niemand mehr.",
    "sie_selbst": "(Sie)",
    "projekte_ausgewaehlt": "Projekte ({n} ausgewählt)",
    "angelegt": "Benutzer {name} angelegt",
    "aktualisiert": "{name} aktualisiert",
    "neues_passwort_frage": "Neues Passwort für {name} (mindestens 15 Zeichen):",
    "passwort_gesetzt": "Passwort für {name} gesetzt",
    "loeschen_frage": "Benutzer „{name}“ wirklich löschen? Das lässt sich nicht rückgängig machen.",
    "geloescht": "{name} gelöscht",
    "geloescht_sitzungen": "{name} gelöscht, {n} offene Sitzung beendet | {name} gelöscht, {n} offene Sitzungen beendet",
    "was": "Dieser Benutzer",
    "fehler": {
      "nicht_selbst": "Sie können sich nicht selbst löschen.",
      "letzter_admin": "Das ist der letzte Admin. Machen Sie vorher einen anderen Zugang zum Admin.",
      "passwort": "Passwort ließ sich nicht setzen",
      "loeschen": "Löschen fehlgeschlagen"
    },
    "konto_rechte": "Darf außerdem",
    "konto_rechte_hinweis": "Diese Rechte verlangen die Anmeldung mit Code (Zwei-Faktor).",
    "recht": {
      "websites_anlegen": "neue Websites anlegen und gestalten",
      "domains_verbinden": "Domains verbinden",
      "kunden_zugang": "Zugänge für Kunden anlegen"
    }
  },
  "zugriff": {
    "mindestens_eine": "Mindestens eine Stellung muss bleiben.",
    "was_einstellung": "Diese Einstellung",
    "was_zugang": "Dieser Zugang",
    "was_link": "Dieser Link",
    "nie_geoeffnet": "noch nie geöffnet",
    "zuletzt": "zuletzt geöffnet am {datum}, {n}×",
    "zugang_unvollstaendig": "Bitte Benutzername und ein Passwort mit mindestens 15 Zeichen angeben.",
    "kopieren_fehler": "Kopieren ging nicht. Bitte markieren Sie den Link von Hand.",
    "erst_texte": "Erst Texte ändern erlauben",
    "aktiv": "Aktiv",
    "aus": "Aus",
    "kopiert": "Kopiert",
    "abschalten": "Abschalten",
    "einschalten": "Einschalten",
    "abschnitte_umbauen": "Abschnitte umbauen",
    "abschnitte_umbauen_hinweis": "Abschnitte einer Seite anlegen, verschieben und löschen",
    "claude_an": "Claude darf in diesem Projekt arbeiten",
    "claude_an_hinweis": "Texte und Aufbau dieser Website gehen dabei an Anthropic. Erst einschalten, wenn der Kunde Bescheid weiß. Claude ändert nur die Vorschau, veröffentlicht wird von Menschen."
  },
  "hinweisseiten": {
    "zustand": {
      "private": "Ohne gültigen Link",
      "expired": "Link abgelaufen",
      "config": "Einstellung fehlt",
      "notfound": "Seite nicht gefunden"
    },
    "feld": {
      "title": "Überschrift",
      "text": "Text",
      "cta": "Knopf"
    },
    "laden_fehler": "Texte konnten nicht geladen werden",
    "gespeichert": "Gespeichert. Auf allen Vorschau-Adressen sofort sichtbar.",
    "zu_lang": "Zu lang: {feld} (höchstens 400 Zeichen)",
    "nur_admins": "Nur Admins dürfen diese Texte ändern.",
    "abweichend": "{n} Text weicht vom Standard ab. | {n} Texte weichen vom Standard ab."
  },
  "farben": {
    "aa_gross": "AA groß · {wert}",
    "zu_niedrig": "zu niedrig · {wert}",
    "laden_fehler": "Farben konnten nicht geladen werden",
    "gespeichert": "Farben gespeichert",
    "gespeichert_text": "Die Seite wurde neu gebaut.",
    "untertitel": "{projekt}: Marken-Farben ändern",
    "keine": "Für dieses Projekt sind keine Farben eingerichtet ({datei} fehlt).",
    "ungueltig": "Ungültige Farbe",
    "alles_gespeichert": "Alles gespeichert",
    "speichert": "Wird gespeichert und gebaut …",
    "speichern": "Speichern & anwenden"
  },
  "alt": {
    "bitte_pruefen": "Bitte prüfen",
    "bild_ersetzt": "Das Bild wurde ersetzt. Passt die Bildbeschreibung noch zum neuen Bild? Vorleseprogramme und Suchmaschinen lesen sie anstelle des Bildes.",
    "jetzt": "Bildbeschreibung jetzt",
    "leer": "(leer)",
    "passt_so": "Passt so",
    "beschreibung_oeffnen": "Bildbeschreibung bearbeiten",
    "passt_so_fehler": "Die Bestätigung wurde nicht gespeichert."
  },
  "abschnitte": {
    "was": "dieser Abschnitt",
    "liste": "Abschnitte dieser Seite",
    "leer": "Diese Seite hat noch keinen Abschnitt.",
    "nur_lesen": "Den Aufbau dieser Seite ändern kann nur, wer dafür freigeschaltet ist. Texte ändern Sie wie gewohnt.",
    "laden_fehlgeschlagen": "Abschnitte konnten nicht geladen werden",
    "ziehen": "Ziehen zum Verschieben",
    "hoch": "{name} nach oben",
    "runter": "{name} nach unten",
    "menue": "Was mit „{name}“ geschehen soll",
    "hinzufuegen": "Abschnitt hinzufügen",
    "darunter_einfuegen": "Abschnitt darunter einfügen",
    "keine_bausteine": "Für dieses Projekt sind keine Bausteine hinterlegt.",
    "variante": "Darstellung",
    "hintergrund": "Hintergrund",
    "hintergrund_standard": "Wie die Seite",
    "gewaehlt": "gewählt",
    "duplizieren": "Duplizieren",
    "loeschen": "Löschen",
    "loeschen_hinweis": "Samt seinen Texten in allen Sprachen",
    "loeschen_frage": "„{name}“ samt seinen Texten in allen Sprachen löschen? Zurückholen geht über den Verlauf.",
    "erledigt": {
      "anlegen": "Abschnitt hinzugefügt",
      "verschieben": "Abschnitt verschoben",
      "duplizieren": "Abschnitt dupliziert",
      "loeschen": "Abschnitt gelöscht",
      "variante": "Darstellung geändert",
      "hintergrund": "Hintergrund geändert",
      "eintrag_anlegen": "Eintrag hinzugefügt",
      "eintrag_verschieben": "Eintrag verschoben",
      "eintrag_loeschen": "Eintrag gelöscht",
      "abstand": "Abstand geändert",
      "schleier": "Abdunklung geändert",
      "anker": "Sprungmarke geändert",
      "ausblenden": "Sichtbarkeit des Abschnitts geändert",
      "geraet": "Sichtbarkeit auf Geräten geändert",
      "bewegung": "Bewegung des Abschnitts geändert"
    },
    "fehler": {
      "kein_recht": "Den Aufbau dieser Seite dürfen Sie nicht ändern.",
      "kein_plan": "Diese Seite ist nicht aus Bausteinen gebaut.",
      "kein_katalog": "Für dieses Projekt sind keine Bausteine hinterlegt.",
      "weg": "Diesen Abschnitt gibt es nicht mehr. Die Liste ist jetzt wieder aktuell.",
      "baustein_unbekannt": "Diesen Baustein kennt die Website nicht.",
      "zu_viele": "Mehr als {max} Abschnitte passen nicht auf eine Seite.",
      "zu_wenige_eintraege": "Mindestens {min} Einträge müssen bleiben.",
      "zu_viele_eintraege": "Mehr als {max} Einträge gehen hier nicht.",
      "ungueltig": "Die Änderung passt nicht zu den Bausteinen der Website und wurde nicht gespeichert.",
      "ohne_titel": "Ohne Titel entsteht keine Seite.",
      "keine_adresse": "Aus diesem Titel lässt sich keine Adresse bilden. Bitte ein paar Buchstaben mehr.",
      "nur_entwurf": "Eine sichtbare Seite kann nur miraTEQ löschen. Stellen Sie sie zuerst zurück auf Entwurf.",
      "eigene_seite": "Diese Seite ist fest eingebaut und lässt sich hier nicht löschen.",
      "gleiche_adresse": "Die Seite hat diese Adresse schon.",
      "adresse_vergeben": "Diese Adresse gehört schon einer anderen Seite. Bitte wählen Sie eine andere.",
      "kein_menue": "Diese Website hat kein Menü, das sich im CMS pflegen lässt.",
      "menue_seite_weg": "Eine Seite im Menü gibt es nicht mehr. Bitte laden Sie neu.",
      "menue_doppelt": "Eine Seite steht zweimal im selben Menü.",
      "menue_zu_viele": "Mehr als {max} Seiten passen nicht in ein Menü.",
      "keine": "Das lässt sich nicht mehr rückgängig machen. Ältere Stände holt der Verlauf zurück.",
      "fremd": "Diese Änderung stammt von jemand anderem. Zurückholen geht über den Verlauf.",
      "konflikt": "Danach wurde an derselben Stelle weitergearbeitet, deshalb geht Rückgängig hier nicht. Zurückholen geht über den Verlauf.",
      "anker_ungueltig": "Diese Sprungmarke geht nicht: nur Kleinbuchstaben, Ziffern und Bindestriche, und einige Namen sind schon vergeben.",
      "anker_doppelt": "Diese Sprungmarke trägt schon ein anderer Abschnitt der Seite.",
      "abstand_unbekannt": "Diesen Abstand kennt die Website nicht. Bitte laden Sie die Seite neu.",
      "schleier_unbekannt": "Diese Abdunklung kennt die Website nicht. Bitte laden Sie die Seite neu.",
      "ausblenden_nicht": "Diese Website kann Abschnitte noch nicht ausblenden.",
      "vorlage_unbekannt": "Diese Vorlage gibt es hier nicht. Bitte laden Sie die Seite neu.",
      "geraet_unbekannt": "Diese Auswahl für die Geräte kennt die Website nicht.",
      "bewegung_unbekannt": "Diese Bewegung kennt die Website nicht. Bitte laden Sie die Seite neu.",
      "menue_link_leer": "Diesem Link fehlen Name oder Ziel. Bitte unter „Für alle Seiten“ beides eintragen."
    },
    "neue_seite": "Neue Seite aus Bausteinen",
    "seitentitel": "Titel der Seite",
    "seitentitel_hinweis": "Daraus entstehen Adresse, Seitentitel und die erste Überschrift. Ändern lässt sich alles später.",
    "neue_seite_entwurf": "Startet als Entwurf. Auf der Website erscheint sie erst, wenn Sie sie sichtbar machen.",
    "eintrag": {
      "gruppe": "{name} {nr} von {von}",
      "stelle": "{name} {nr} von {von}",
      "hoch": "Nach oben",
      "runter": "Nach unten",
      "dazu": "{name} dazu",
      "loeschen": "Löschen",
      "loeschen_frage": "{name} {nr} samt Text in allen Sprachen löschen?"
    },
    "wird_angelegt": "Wird angelegt …",
    "vorschau_neu": "Neuer Abschnitt: {name}. Wird gebaut …",
    "vorschau_wartet": "Wird aktualisiert …",
    "abstand": "Abstand oben und unten",
    "abstand_normal": "Normal",
    "hoehe": "Höhe des Einstiegs",
    "hoehe_kompakt": "Kompakt",
    "hoehe_normal": "Normal",
    "hoehe_gross": "Bildschirmfüllend",
    "schleier": "Abdunklung des Bildes",
    "schleier_normal": "Normal",
    "anker_setzen": "Sprungmarke setzen",
    "anker_aendern": "Sprungmarke #{anker} ändern",
    "anker_hinweis": "Ein Knopf führt dann hierher",
    "anker_titel": "Sprungmarke für diesen Abschnitt",
    "anker_erklaerung": "Ein Knopf mit dem Ziel #{anker} springt zu diesem Abschnitt.",
    "anker_ungueltig": "Nur Kleinbuchstaben, Ziffern und Bindestriche, vorne ein Buchstabe.",
    "anker_entfernen": "Entfernen",
    "ausblenden": "Ausblenden",
    "ausblenden_hinweis": "Bleibt erhalten, geht aber nicht live",
    "einblenden": "Wieder einblenden",
    "ausgeblendet": "ausgeblendet",
    "seite_kopieren": "„{name}“ kopieren",
    "vorlage": "Womit beginnen?",
    "seite_duplizieren": "Seite kopieren",
    "seite_duplizieren_hinweis": "Als Entwurf unter neuem Titel",
    "vorlagen": {
      "leer": "Leer",
      "leistungen": "Leistungen",
      "ueber-uns": "Über uns",
      "preise": "Preise",
      "kontakt": "Kontakt",
      "gutschein": "Gutschein",
      "beitrag": "Beitrag",
      "neuigkeiten": "Neuigkeiten"
    },
    "vorlagen_hinweis": {
      "leer": "Nur ein Einstieg, den Rest fügen Sie selbst hinzu",
      "leistungen": "Einstieg, Leistungen, Vorteile, Fragen, Aufruf",
      "ueber-uns": "Einstieg, Text mit Bild, Zahlen, Team, Zitat, Aufruf",
      "preise": "Einstieg, Preisliste, Fragen, Aufruf",
      "kontakt": "Einstieg, Formular, Öffnungszeiten, Karte",
      "gutschein": "Einstieg, Text mit Bild, Ablauf, Fragen, Aufruf",
      "beitrag": "Einstieg, Text, Aufruf, mit Datum von heute",
      "neuigkeiten": "Einstieg, alle Beiträge"
    },
    "geraet": "Sichtbar auf",
    "geraet_alle": "Allen Geräten",
    "bewegung": "Bewegung beim Scrollen",
    "bewegung_website": "Wie die ganze Website"
  },
  "webmenue": {
    "titel": "Menü der Website",
    "kopf": "Oben in der Kopfzeile",
    "fuss": "Unten in der Fußzeile",
    "leer": "Hier steht noch keine Seite.",
    "entfernen": "{name} aus diesem Menü nehmen",
    "hinzufuegen": "Seite hinzufügen: {wo}",
    "voll": "Mehr als {max} Seiten passen nicht hinein",
    "seite_hinzufuegen": "Seite hinzufügen …",
    "name_hinweis": "Wie eine Seite im Menü heißt, ändern Sie auf der Seite selbst, im Feld „Name im Menü“.",
    "bearbeiten": "Menü bearbeiten",
    "rein": "Ins Menü aufnehmen",
    "rein_hinweis": "Erscheint oben in der Kopfzeile, ganz hinten",
    "raus": "Aus dem Menü nehmen",
    "raus_hinweis": "Die Seite bleibt, sie steht nur nicht mehr im Menü",
    "drin": "„{name}“ steht jetzt im Menü",
    "draussen": "„{name}“ steht nicht mehr im Menü",
    "einruecken": "„{name}“ unter die Seite darüber einrücken",
    "ausruecken": "„{name}“ wieder nach oben ins Menü",
    "links_hinweis": "Eigene Links, etwa zur Online-Buchung oder zu „/#preise“, legen Sie unter „Für alle Seiten“ in der Gruppe Menü an. Danach stehen sie hier mit Pfeil zur Auswahl."
  },
  "adresse": {
    "titel": "Adresse von „{name}“ ändern",
    "feld": "Neue Adresse",
    "vorschau": "Wird zu",
    "regeln": "Bitte mindestens drei Buchstaben oder Ziffern.",
    "hinweis_entwurf": "Die Seite ist noch ein Entwurf. Die alte Adresse war nie öffentlich und braucht keine Weiterleitung.",
    "hinweis_weiterleitung": "Wer die alte Adresse aufruft, landet danach auf der neuen. Links und Einträge bei Google bleiben gültig.",
    "aendern": "Adresse ändern",
    "wird_geaendert": "Wird geändert …",
    "menue": "Adresse ändern",
    "menue_hinweis": "Alte Links funktionieren weiter",
    "erst_speichern": "Auf dieser Seite gibt es ungespeicherte Änderungen. Speichern Sie zuerst, dann lässt sich die Adresse ändern.",
    "geaendert": "Die Seite hat jetzt die Adresse {adresse}"
  },
  "rueckgaengig": {
    "knopf": "Rückgängig: {was}",
    "knopf_vor": "Wiederholen: {was}",
    "titel_zurueck": "Rückgängig: {was} (Cmd+Z)",
    "titel_vor": "Wiederholen: {was} (Cmd+Shift+Z)",
    "kuerzel_zurueck": "Cmd+Z",
    "kuerzel_vor": "Cmd+Shift+Z",
    "nichts": "Nichts rückgängig zu machen",
    "nichts_vor": "Nichts zu wiederholen",
    "erledigt": "Rückgängig gemacht: {was}",
    "wiederholt": "Wiederholt: {was}",
    "ging_nicht": "Rückgängig ging nicht",
    "art": {
      "anlegen": "Abschnitt hinzugefügt",
      "verschieben": "Abschnitt verschoben",
      "duplizieren": "Abschnitt dupliziert",
      "loeschen": "Abschnitt gelöscht",
      "variante": "Darstellung geändert",
      "hintergrund": "Hintergrund geändert",
      "eintrag_anlegen": "Eintrag hinzugefügt",
      "eintrag_verschieben": "Eintrag verschoben",
      "eintrag_loeschen": "Eintrag gelöscht",
      "sichtbar": "Seite sichtbar gemacht",
      "entwurf": "Seite auf Entwurf gestellt",
      "seite_anlegen": "Seite angelegt",
      "seite_loeschen": "Seite gelöscht",
      "adresse": "Adresse geändert",
      "menue": "Menü geändert",
      "abstand": "Abstand geändert",
      "schleier": "Abdunklung geändert",
      "anker": "Sprungmarke geändert",
      "ausblenden": "Sichtbarkeit des Abschnitts geändert",
      "suche_aus": "Seite aus Suchmaschinen genommen",
      "suche_an": "Seite wieder in Suchmaschinen",
      "geraet": "Sichtbarkeit auf Geräten geändert",
      "bewegung": "Bewegung des Abschnitts geändert",
      "landing_an": "Seite als Landingpage, ohne Menü",
      "landing_aus": "Seite wieder mit Menü",
      "beitrag_an": "Seite als Beitrag",
      "beitrag_aus": "Seite ist kein Beitrag mehr"
    }
  },
  "claude": {
    "titel": "Claude verbinden",
    "einleitung": "Mit Ihrem eigenen Claude können Sie Texte und Abschnitte per Auftrag ändern lassen, etwa „Schreib die Fragen auf der Startseite verständlicher“. Claude arbeitet mit Ihren Rechten, nur in Projekten, für die miraTEQ es eingeschaltet hat, und nur in der Vorschau. Veröffentlichen bleibt bei Ihnen. Jede Person braucht ihr eigenes Claude-Konto.",
    "ist_aus": "Claude ist gerade für alle gesperrt. Ihre Schlüssel bleiben gültig und funktionieren wieder, sobald die Sperre aufgehoben ist.",
    "neuer_schluessel": "Neuen Schlüssel erzeugen",
    "name": "Wofür, damit Sie ihn später erkennen",
    "name_beispiel": "Claude auf dem Laptop",
    "erzeugen": "Erzeugen",
    "nur_einmal": "Der Schlüssel steht nur jetzt hier. Tragen Sie ihn gleich ein; danach kennt miraCMS ihn nicht mehr.",
    "app_schritt": "In der Claude-App unter Einstellungen bei den Connectors einen eigenen Connector hinzufügen, mit dieser Adresse, und bei den Kopfzeilen „Authorization“ mit diesem Wert:",
    "adresse": "Adresse",
    "kopfzeile": "Wert für Authorization",
    "code_schritt": "Oder in Claude Code diesen Befehl ausführen:",
    "kopieren": "Kopieren",
    "kopiert": "Kopiert",
    "nicht_kopiert": "Kopieren ging nicht. Bitte markieren und von Hand kopieren.",
    "fertig_eingetragen": "Eingetragen, ausblenden",
    "meine": "Meine Schlüssel",
    "keine": "Noch kein Schlüssel.",
    "erzeugt_am": "erzeugt {datum}",
    "zuletzt_am": "zuletzt benutzt {datum}",
    "nie": "nie",
    "abschalten": "Abschalten",
    "abgeschaltet": "abgeschaltet",
    "abschalten_frage": "Schlüssel „{name}“ abschalten? Claude kommt damit sofort nicht mehr herein.",
    "notschalter": "Notschalter",
    "notschalter_hinweis": "Sperrt alle Claude-Schlüssel auf einmal, in allen Projekten. Für den Fall, dass etwas schiefläuft und keine Zeit zum Suchen ist.",
    "schalter_aus": "Claude für alle sperren",
    "schalter_an": "Sperre aufheben",
    "schalter_aus_erledigt": "Claude ist für alle gesperrt",
    "schalter_an_erledigt": "Claude ist wieder freigegeben",
    "laden_fehler": "Claude-Einstellungen konnten nicht geladen werden",
    "erzeugen_fehler": "Schlüssel konnte nicht erzeugt werden",
    "letzte_aenderung": "Letzte Änderung durch Claude",
    "zuruecknehmen": "Zurücknehmen",
    "zuruecknehmen_frage": "Die Claude-Änderung „{was}“ zurücknehmen? Was danach von Hand geändert wurde, bleibt.",
    "zurueckgenommen": "Claude-Änderung zurückgenommen",
    "konflikt": "Die Stelle wurde danach von Hand geändert. Bitte über den Verlauf der Felder einzeln zurückholen."
  },
  "assistent": {
    "titel": "Assistent",
    "einleitung": "Der Assistent ist eine KI (Claude von Anthropic). Schreiben Sie, was auf der Website anders werden soll: Er ändert Texte und Abschnitte in der Vorschau, veröffentlicht wird erst, wenn Sie es freigeben.",
    "verlauf": "Gespräch mit dem Assistenten",
    "beispiele_titel": "Zum Beispiel:",
    "beispiel_1": "Schreib die Überschrift oben freundlicher.",
    "beispiel_2": "Füge eine Frage zu den Öffnungszeiten hinzu.",
    "beispiel_3": "Verschiebe die häufigen Fragen ans Ende der Seite.",
    "eingabe": "Ihr Auftrag an den Assistenten",
    "platzhalter": "Was soll sich ändern?",
    "senden": "Senden",
    "arbeitet": "Arbeitet …",
    "denkt": "Liest und überlegt …",
    "neues_gespraech": "Neues Gespräch",
    "bild_anhaengen": "Bild anhängen",
    "bild_laedt": "Lädt hoch …",
    "bild_fehler": "Das Bild ließ sich nicht hochladen.",
    "bild_hoechstens": "Höchstens {n} Bilder je Nachricht.",
    "bild_entfernen": "Bild {nr} entfernen",
    "bilder_angehaengt": "Angehängte Bilder",
    "budget": "Diesen Monat {verbraucht} von {grenze}",
    "kosten_gespraech": "dieses Gespräch {usd}",
    "aenderungen": "{n} Änderung in der Vorschau | {n} Änderungen in der Vorschau",
    "zuruecknehmen": "Zurücknehmen",
    "zurueckgenommen": "Änderungen zurückgenommen",
    "nicht_gesendet": "Nicht gesendet",
    "schritt_abgelehnt": "abgelehnt",
    "grund_admin": "Einrichten unter Einstellungen, Reiter Claude, Abschnitt Assistent im CMS.",
    "schritt": {
      "list_pages": "Sieht die Seiten durch",
      "list_blocks": "Sieht die Bausteine durch",
      "read_page": "Liest die Seite",
      "view_page": "Sieht sich die Seite an",
      "list_media": "Sieht die Bilder durch",
      "set_texts": "Ändert Texte",
      "add_section": "Fügt einen Abschnitt hinzu",
      "move_section": "Verschiebt einen Abschnitt",
      "duplicate_section": "Kopiert einen Abschnitt",
      "delete_section": "Löscht einen Abschnitt",
      "configure_section": "Ändert die Darstellung",
      "add_entry": "Fügt einen Eintrag hinzu",
      "move_entry": "Verschiebt einen Eintrag",
      "delete_entry": "Löscht einen Eintrag",
      "create_page": "Legt eine Seite an",
      "search_stock_images": "Sucht Fotos",
      "import_image": "Übernimmt ein Foto",
      "list_styles": "Sieht die Stilrichtungen durch",
      "set_style": "Ändert das Aussehen",
      "build_page": "Baut eine ganze Seite",
      "set_menu": "Ordnet das Menü",
      "sonst": "Arbeitet",
      "set_brand_profile": "Speichert das Markenprofil"
    },
    "grund": {
      "abgeschaltet": "Der Assistent ist auf dieser Installation ausgeschaltet.",
      "kein_schluessel": "Der Assistent ist noch nicht eingerichtet.",
      "bilder": "Ein angehängtes Bild ist nicht mehr in der Mediathek. Bitte hängen Sie es neu an.",
      "ki_aus": "Für dieses Projekt ist Claude nicht freigeschaltet.",
      "notschalter": "Claude ist gerade für alle gesperrt.",
      "kein_recht": "Sie dürfen in diesem Projekt keine Texte ändern.",
      "budget": "Die Grenze für diesen Monat ist erreicht.",
      "laeuft_schon": "Der Assistent arbeitet noch am letzten Auftrag.",
      "schluessel_ungueltig": "Anthropic hat den Zugang abgelehnt. Bitte geben Sie miraTEQ Bescheid.",
      "limit": "Das Monatslimit bei Anthropic ist erreicht.",
      "guthaben": "Das Claude-Guthaben dieses Monats ist aufgebraucht. Neues kommt mit der nächsten Monatsabrechnung.",
      "ueberlastet": "Claude ist gerade überlastet. Bitte versuchen Sie es in einer Minute noch einmal.",
      "netz": "Claude war nicht erreichbar. Bitte versuchen Sie es noch einmal.",
      "abgebrochen": "Der Auftrag wurde abgebrochen. Bitte schicken Sie ihn noch einmal.",
      "unbekannt": "Das hat nicht geklappt. Bitte versuchen Sie es noch einmal."
    },
    "einstellungen": {
      "titel": "Assistent im CMS",
      "text": "Damit der Assistent im Panel arbeiten kann, braucht miraCMS einen API-Schlüssel aus der Claude Console von Anthropic. Zu einem Max- oder Team-Abo gehört monatliches Guthaben: Auf claude.ai unter Einstellungen, Billing, die Console-Organisation verknüpfen und dort den Schlüssel anlegen. Ist das Guthaben aufgebraucht, pausiert der Assistent bis zur nächsten Monatsabrechnung. Die Grenzen hier gelten zusätzlich.",
      "schluessel": "API-Schlüssel",
      "schluessel_da": "Hinterlegt, endet auf {ende}",
      "schluessel_fehlt": "Kein Schlüssel hinterlegt",
      "schluessel_neu": "Neuer Schlüssel",
      "schluessel_speichern": "Schlüssel speichern",
      "schluessel_entfernen": "Schlüssel entfernen",
      "entfernen_frage": "Den Schlüssel entfernen? Der Assistent arbeitet dann nicht mehr.",
      "fehler_schluessel": "Das sieht nicht nach einem API-Schlüssel von Anthropic aus, der beginnt mit sk-ant-.",
      "modell": "Modell",
      "modell_sonnet": "Sonnet 5.5, empfohlen",
      "modell_haiku": "Haiku 5.5, günstiger",
      "modell_opus": "Opus 5.5, gründlicher und teurer",
      "grenze_projekt": "Grenze je Projekt und Monat in US-Dollar",
      "grenze_gesamt": "Grenze für alle Projekte und Monat in US-Dollar",
      "speichern": "Speichern",
      "gespeichert": "Gespeichert",
      "laden_fehler": "Einstellungen konnten nicht geladen werden",
      "verbrauch": "Verbrauch im Monat {monat}",
      "verbrauch_gesamt": "zusammen {usd}",
      "kein_verbrauch": "Noch nichts verbraucht.",
      "spalte_projekt": "Projekt",
      "spalte_auftraege": "Aufträge",
      "spalte_kosten": "Kosten"
    },
    "auftrag_uebersetzen": "Übersetze die Seite „{name}“ ({seite}) in alle weiteren Sprachen der Website. Bedeutung und Ton wie im Original, Längen einhalten, kein PLATZHALTER darf stehen bleiben.",
    "umschreiben": "Mit Claude",
    "umschreiben_kuerzer": "Kürzer",
    "umschreiben_freundlicher": "Freundlicher",
    "umschreiben_variante": "Andere Fassung",
    "auftrag_kuerzer": "Schreib im Feld „{feld}“ (Schlüssel {key}) auf der Seite „{seite}“ in der Sprache {lang} eine kürzere Fassung. Inhalt und Ton bleiben, nur knapper.",
    "auftrag_freundlicher": "Schreib im Feld „{feld}“ (Schlüssel {key}) auf der Seite „{seite}“ in der Sprache {lang} eine freundlichere, wärmere Fassung. Inhalt bleibt, keine neuen Behauptungen.",
    "auftrag_variante": "Schreib im Feld „{feld}“ (Schlüssel {key}) auf der Seite „{seite}“ in der Sprache {lang} eine andere Fassung mit neuen Worten. Inhalt, Länge und Ton bleiben ähnlich.",
    "vorher_pruefen": "Erst von Claude prüfen lassen",
    "auftrag_pruefen": "Bitte vor dem Veröffentlichen alle Seiten in allen Sprachen durchsehen: übrig gebliebene Platzhalter, Tippfehler, widersprüchliche Angaben wie verschiedene Preise oder Zeiten, leere Bildbeschreibungen und Texte, die nicht zum Markenprofil passen. Nichts ändern, nur die Stellen mit Seite und Feld nennen.",
    "auftrag_sprache": "Übersetze alle Seiten der Website in die Sprache {name} ({lang}). Die Texte dort sind noch Kopien der Hauptsprache. Bedeutung und Ton wie im Original, Längen einhalten, Seite für Seite, und melde am Ende, ob alles übersetzt ist."
  },
  "mediathek": {
    "titel": "Mediathek",
    "hinweis": "Alle Bilder des Projekts",
    "auswahl_titel": "Bild aus der Mediathek",
    "aus_der_mediathek": "Aus der Mediathek",
    "anzahl": "{n} Bild | {n} Bilder",
    "suche": "In der Mediathek suchen",
    "suche_platzhalter": "Dateiname",
    "nur_ungenutzte": "Nur ungenutzte",
    "hochladen": "Hochladen",
    "bilder": "Bilder",
    "laedt": "Bilder werden geladen …",
    "was": "Die Mediathek",
    "leer": "In diesem Projekt liegt noch kein Bild.",
    "nichts_gefunden": "Kein Bild passt zu dieser Suche.",
    "im_feld": "Im Feld",
    "stand": {
      "verwendet": "An {n} Stelle verwendet | An {n} Stellen verwendet",
      "genannt": "In {n} Datei genannt | In {n} Dateien genannt",
      "frei": "Nicht verwendet",
      "eingebaut": "Teil der Gestaltung",
      "in_arbeit": "In einem ungespeicherten Feld"
    },
    "masse": "{breite} × {hoehe} px",
    "kb": "{n} KB",
    "mb": "{n} MB",
    "zurueck": "Alle Bilder",
    "verwendet_auf": "Verwendet auf",
    "zum_feld": "Zum Feld springen",
    "genannt_in": "Außerdem genannt in",
    "genannt_hinweis": "Diese Dateien gehören zur Website selbst. Dort pflegt miraTEQ das Bild.",
    "eingebaut_hinweis": "Dieses Bild kam mit dem Code der Website und gehört zu ihrer Gestaltung. Löschen kann es nur miraTEQ.",
    "in_arbeit_hinweis": "Sie haben dieses Bild in ein Feld gesetzt, das noch nicht gespeichert ist. Deshalb lässt es sich nicht löschen.",
    "frei_hinweis": "Dieses Bild steht auf keiner Seite und in keiner Datei. Sie können es löschen.",
    "loeschen": "Bild löschen",
    "loeschen_frage": "„{name}“ endgültig löschen?",
    "loeschen_text": "Das Bild verschwindet aus dem Projekt. Zurückholen kann es nur miraTEQ.",
    "loescht": "Wird gelöscht …",
    "geloescht": "„{name}“ gelöscht",
    "nicht_gesichert": "Gelöscht, aber noch nicht gesichert",
    "nicht_gesichert_text": "Die Änderung liegt auf dem Server, ist aber noch nicht bei GitHub. Bitte geben Sie miraTEQ Bescheid, bevor Sie veröffentlichen.",
    "fehler": {
      "in_gebrauch": "Das Bild steht inzwischen an einer anderen Stelle und bleibt deshalb.",
      "fest_eingebaut": "Dieses Bild gehört zur Gestaltung der Website. Löschen kann es nur miraTEQ.",
      "nicht_gefunden": "Dieses Bild gibt es nicht mehr.",
      "nicht_gesichert": "Das Löschen ließ sich nicht sichern, das Bild ist noch da. Bitte versuchen Sie es noch einmal.",
      "loeschen": "Das Bild ließ sich nicht löschen. Bitte versuchen Sie es noch einmal."
    },
    "reiter": "Bildquelle",
    "reiter_mediathek": "Eigene Bilder",
    "reiter_stock": "Stockfotos",
    "reiter_ki": "KI-Bild"
  },
  "werkbank": {
    "fortschritt": "Fortschritt",
    "in_arbeit": "Neue Websites in Arbeit",
    "noch_einmal": "Noch einmal versuchen",
    "laeuft_weiter": "Das läuft auch weiter, wenn Sie dieses Fenster schließen.",
    "stand": {
      "erledigt": "erledigt",
      "laeuft": "läuft gerade",
      "offen": "noch nicht begonnen",
      "gestoppt": "abgebrochen"
    },
    "schritt": {
      "website_anlegen": {
        "werkbank": "Website aus der Vorlage anlegen",
        "klonen": "Auf den Server holen",
        "pakete": "Bausteine installieren",
        "startpaket": "Startpaket der Branche anlegen",
        "bauen": "Erste Vorschau bauen"
      },
      "domain_vorbereiten": {
        "werkbank": "Domain bei Cloudflare anlegen und bisherige Einträge übernehmen",
        "adresse": "Adresse der Website umstellen"
      },
      "domain_aktivieren": {
        "werkbank": "Website an die Domain hängen",
        "rauchtest": "Von außen prüfen, ob die Seite ankommt (das Zertifikat kann ein paar Minuten dauern)"
      }
    },
    "fehler": {
      "forbidden": "Dafür fehlt Ihrem Zugang das Recht.",
      "zwei_faktor_noetig": "Dafür braucht Ihr Zugang die Anmeldung mit Code (Zwei-Faktor). Bitte schalten Sie sie zuerst unter Konto ein.",
      "bestaetigung_noetig": "Bitte bestätigen Sie den Schritt mit dem Code aus Ihrer App.",
      "werkbank_nicht_eingerichtet": "Das Anlegen neuer Websites ist noch nicht eingerichtet. Bitte bei miraTEQ melden.",
      "cloudflare_nicht_eingerichtet": "Das Veröffentlichen bei Cloudflare ist noch nicht eingerichtet. Bitte bei miraTEQ melden.",
      "name_fehlt": "Bitte den Namen des Betriebs eintragen.",
      "name_ungueltig": "Der Name ist zu lang oder enthält Zeichen, die nicht gehen.",
      "kurzname_ungueltig": "Der Kurzname darf nur Kleinbuchstaben, Ziffern und einzelne Bindestriche haben, 3 bis 32 Zeichen, vorne ein Buchstabe.",
      "kurzname_vergeben": "Diesen Kurznamen gibt es schon. Bitte wählen Sie einen anderen.",
      "land_ungueltig": "Bitte Deutschland oder Thailand wählen.",
      "sprachen_ungueltig": "Bitte mindestens eine Sprache wählen und eine davon als Hauptsprache.",
      "farbe_ungueltig": "Die Farbe ist ungültig.",
      "branche_ungueltig": "Diese Branche gibt es nicht.",
      "repo_gibt_es_schon": "Für diesen Kurznamen gibt es schon eine Website. Bitte wählen Sie einen anderen.",
      "lauf_nicht_gefunden": "Die Werkbank hat den Auftrag nicht angenommen. Bitte später noch einmal versuchen oder miraTEQ Bescheid geben.",
      "lauf_zu_lang": "Der Auftrag hat zu lange gedauert und wurde abgebrochen. Bitte miraTEQ Bescheid geben.",
      "kein_ergebnis": "Die Werkbank hat kein Ergebnis geliefert. Bitte miraTEQ Bescheid geben.",
      "klonen_fehlgeschlagen": "Die neue Website ließ sich nicht auf den Server holen. Bitte miraTEQ Bescheid geben.",
      "pakete_fehlgeschlagen": "Die Bausteine ließen sich nicht installieren. Bitte miraTEQ Bescheid geben.",
      "erster_bau_fehlgeschlagen": "Die erste Vorschau ließ sich nicht bauen. Bitte miraTEQ Bescheid geben.",
      "zugang_abgelehnt": "Die Werkbank hat den Zugang abgelehnt. Bitte miraTEQ Bescheid geben.",
      "werkbank_fehlt": "Die Werkbank ist nicht erreichbar. Bitte miraTEQ Bescheid geben.",
      "github_gestoert": "GitHub ist gerade gestört. Bitte in ein paar Minuten noch einmal versuchen.",
      "netz": "Keine Verbindung. Bitte noch einmal versuchen.",
      "tagesgrenze": "Für heute sind genug neue Websites oder Domains angelegt. Morgen geht es wieder.",
      "domain_ungueltig": "Das ist keine Domain, die sich verbinden lässt. Bitte nur den Namen ohne www und ohne Unterseite eintragen, etwa kunde.de.",
      "domain_gesperrt": "Diese Domain gehört zu miraTEQ und lässt sich hier nicht verbinden.",
      "domain_schon_aktiv": "Die Domain ist schon verbunden.",
      "laeuft_schon": "Für dieses Projekt läuft gerade schon ein Auftrag. Bitte warten Sie, bis er fertig ist.",
      "zone_noch_nicht_aktiv": "Cloudflare hat die Domain noch nicht übernommen. Sind die Nameserver beim Anbieter umgestellt? Das kann einige Stunden dauern.",
      "rauchtest_fehlgeschlagen": "Die Website antwortet unter der Domain noch nicht. Bitte miraTEQ Bescheid geben.",
      "email_ungueltig": "Das ist keine gültige E-Mail-Adresse.",
      "mail_nicht_verschickt": "Die Bestätigungsmail ließ sich nicht verschicken. Bitte später noch einmal versuchen.",
      "link_ungueltig": "Der Link gilt nicht mehr.",
      "benutzername_ungueltig": "Der Benutzername darf nur Kleinbuchstaben, Ziffern, Punkt, Unterstrich und Bindestrich haben, 2 bis 32 Zeichen.",
      "benutzername_vergeben": "Diesen Benutzernamen gibt es schon.",
      "nur_kunde": "Freigeben kann nur der Kunde selbst.",
      "vorabpruefung_offen": "Die Prüfung vor dem Livegang hat noch etwas gefunden, das vorher erledigt sein muss.",
      "erster_livegang_unvollstaendig": "Für den ersten Livegang fehlt noch etwas.",
      "adresse_nicht_gespeichert": "Die neue Adresse ließ sich nicht speichern. Bitte miraTEQ Bescheid geben.",
      "unbekannt": "Das hat nicht geklappt. Bitte noch einmal versuchen oder miraTEQ Bescheid geben.",
      "adresse_fehlt": "Für diese Website ist keine Adresse eingetragen. Bitte melden Sie sich bei miraTEQ.",
      "erster_livegang_nur_im_panel": "Den ersten Livegang dieser Website gibt es nur über „Auf Live veröffentlichen“.",
      "domain_ausserhalb": "Die Domain dieser Website ist schon verbunden, miraTEQ verwaltet sie."
    },
    "neu": {
      "knopf": "Neue Website",
      "titel": "Neue Website anlegen",
      "laeuft": "Die Website „{name}“ wird angelegt.",
      "fertig": "Die Website „{name}“ ist angelegt.",
      "oeffnen": "Website öffnen",
      "nicht_eingerichtet": "Das Anlegen neuer Websites ist noch nicht eingerichtet. Bitte bei miraTEQ melden.",
      "name": "Name des Betriebs",
      "kurzname": "Kurzname",
      "kurzname_hinweis": "Für die interne Adresse: Kleinbuchstaben, Ziffern und Bindestriche, 3 bis 32 Zeichen.",
      "land": "Land",
      "sprachen": "Sprachen der Website",
      "hauptsprache": "Hauptsprache:",
      "branche": "Branche",
      "branche_allgemein": "Startet mit Startseite und Kontakt, alles Weitere bauen Sie selbst.",
      "branche_paket": "Startet mit Stil, Startseite und passenden Seiten, die Texte als Platzhalter. Alles lässt sich danach ändern.",
      "farbe": "Markenfarbe",
      "knopf_beispiel": "So sieht ein Knopf aus",
      "knopf_dunkler": "Für Knöpfe mit weißer Schrift nimmt die Website einen dunkleren Ton ({ton}), damit sie gut lesbar bleibt.",
      "wird_angelegt": "Wird angelegt …",
      "anlegen": "Website anlegen"
    },
    "zwei_faktor_zuerst": "Für neue Websites und Domains braucht Ihr Zugang die Anmeldung mit Code (Zwei-Faktor). Bitte schalten Sie sie zuerst ein.",
    "zwei_faktor_einrichten": "Zwei-Faktor einrichten",
    "land": {
      "DE": "Deutschland",
      "TH": "Thailand"
    },
    "sprache": {
      "de": "Deutsch",
      "en": "Englisch",
      "th": "Thai"
    },
    "branche": {
      "allgemein": "Allgemein (ohne Startpaket)",
      "massage": "Massage und Spa",
      "restaurant": "Restaurant und Café",
      "praxis": "Praxis und Therapie",
      "hotel": "Hotel und Unterkunft",
      "handwerk": "Handwerk und Service"
    }
  },
  "bestaetigung": {
    "titel": "Mit Code bestätigen",
    "text": "Dieser Schritt betrifft eine Domain oder eine neue Website. Bitte geben Sie den Code aus Ihrer Authenticator-App ein; danach fragt miraCMS zehn Minuten lang nicht wieder.",
    "code": "Code",
    "weiter": "Bestätigen",
    "falsch": "Der Code stimmt nicht. Bitte geben Sie den aktuellen Code ein.",
    "gesperrt": "Zu viele Versuche. Bitte in einer Viertelstunde noch einmal.",
    "fehler": "Das hat nicht geklappt. Bitte noch einmal versuchen."
  },
  "einrichtung": {
    "knopf": "Einrichtung",
    "knopf_hinweis": "Domain, Kontaktformular und Freigabe des Kunden",
    "titel": "Einrichtung: {name}",
    "fehlt_titel": "Für den ersten Livegang fehlt noch",
    "bereit": "Alles da. Die Website kann zum ersten Mal live gehen.",
    "kopiert": "Kopiert",
    "kopieren": "Kopieren",
    "fehlt": {
      "domain_fehlt": "Die Domain ist noch nicht verbunden.",
      "nameserver_fehlen": "Die Nameserver sind beim Anbieter der Domain noch nicht umgestellt.",
      "abnahme_fehlt": "Der Kunde hat die Website noch nicht freigegeben.",
      "formular_empfaenger_fehlt": "Das Kontaktformular hat noch keine bestätigte Empfängeradresse."
    },
    "domain": {
      "titel": "Domain",
      "status": {
        "vorbereitet": "wartet auf die Nameserver",
        "nameserver": "Nameserver umgestellt",
        "aktiv": "verbunden"
      },
      "nameserver_eintragen": "Beim Anbieter der Domain (zum Beispiel IONOS oder Strato) diese zwei Nameserver eintragen. Das macht der Kunde, oder Sie mit seinem Zugang:",
      "anleitung_kopieren": "Anleitung für den Kunden kopieren",
      "jetzt_pruefen": "Jetzt prüfen",
      "nameserver_ok": "Die Nameserver stimmen. Beim ersten Livegang wird die Website an die Domain gehängt.",
      "aktiv_seit": "Verbunden seit {datum}.",
      "eintraege": "{n} übernommener Eintrag | {n} übernommene Einträge",
      "fehlen": "{n} Eintrag ließ sich nicht übernehmen | {n} Einträge ließen sich nicht übernehmen",
      "typ": "Typ",
      "name": "Name",
      "inhalt": "Inhalt",
      "erklaerung": "Die Domain des Kunden zieht zu Cloudflare um. Die bisherigen Einträge, auch die für E-Mail, übernimmt miraCMS; die Website hängt erst beim ersten Livegang daran.",
      "feld": "Domain",
      "beispiel": "kunde.de",
      "vorbereiten": "Vorbereiten",
      "hauptadresse": "Hauptadresse",
      "ohne_www": "ohne www",
      "mit_www": "mit www",
      "kein_recht": "Eine Domain verbinden nur Zugänge mit diesem Recht.",
      "anleitung_text": "Bitte stellen Sie bei Ihrem Domain-Anbieter für {domain} die Nameserver um auf {ns1} und {ns2}. Alle anderen Einstellungen bleiben, wie sie sind, und Ihre E-Mail läuft weiter. Die Umstellung kann einige Stunden dauern.",
      "erst_klaeren": "Einige bisherige Einträge ließen sich nicht übernehmen (siehe unten). Bitte die Nameserver noch nicht umstellen, sonst kann E-Mail des Kunden verloren gehen, und miraTEQ Bescheid geben.",
      "ausserhalb": "Die Domain ist verbunden. miraTEQ hat sie beim Umzug zu Cloudflare eingerichtet."
    },
    "formular": {
      "titel": "Kontaktformular",
      "bestaetigt": "bestätigt",
      "wartet": "wartet auf Bestätigung",
      "noetig": "Die Website hat ein Kontaktformular. Wohin sollen die Anfragen gehen?",
      "optional": "Falls die Website ein Kontaktformular bekommt: Wohin sollen die Anfragen gehen?",
      "feld": "E-Mail-Adresse für Anfragen",
      "beispiel": "Adresse für Anfragen",
      "senden": "Bestätigungslink senden",
      "gesendet": "Die Adresse bekommt eine Mail mit einem Link zum Bestätigen."
    },
    "abnahme": {
      "titel": "Freigabe durch den Kunden",
      "freigegeben": "Freigegeben von {name} am {datum}.",
      "offen": "Noch nicht freigegeben. Schicken Sie dem Kunden den Gast-Link; dort klickt er „Website freigeben“.",
      "gast_link": "Gast-Link öffnen"
    },
    "zugang": {
      "titel": "Zugang für den Kunden",
      "einmalig": "Das Passwort steht nur jetzt da. Bitte geben Sie es sicher an den Kunden weiter; er kann es danach selbst ändern.",
      "name": "Name",
      "benutzername": "Benutzername",
      "anlegen": "Zugang anlegen"
    }
  },
  "gestalten": {
    "titel": "Schrift und Ecken",
    "schrift": "Schrift",
    "mit_thai": "{name} (mit Thai)",
    "ecken": "Ecken von Knöpfen und Karten",
    "ecken_eckig": "eckig",
    "ecken_leicht": "leicht rund",
    "ecken_rund": "rund",
    "logo_hinweis": "Logo und Seitensymbol pflegen Sie im Editor bei den Feldern für alle Seiten.",
    "knopf_dunkler": "Knöpfe mit weißer Schrift bekommen den dunkleren Ton {ton}, damit sie gut lesbar sind.",
    "stile_titel": "Stilrichtung",
    "stile_hinweis": "Eine Stilrichtung setzt Farben, Schriften und Ecken zusammen. Danach können Sie jeden Wert einzeln anpassen.",
    "schrift_ueberschrift": "Schrift der Überschriften",
    "wie_text": "Wie der Text",
    "fehler": {
      "zu_wenig_kontrast": "Diese Farbe hat zu wenig Kontrast: Text auf dem Seitenhintergrund oder weiße Schrift auf den dunklen Abschnitten wäre schwer lesbar. Bitte wählen Sie einen anderen Ton.",
      "invalid_color": "Eine Farbe hat kein gültiges Format. Bitte wählen Sie sie neu.",
      "ungueltige_schrift": "Diese Schrift passt nicht für Fließtext. Bitte wählen Sie eine andere.",
      "ungueltige_schrift_ueberschrift": "Diese Schrift gibt es hier nicht. Bitte wählen Sie eine andere.",
      "ungueltige_ecken": "Diese Ecken gibt es nicht. Bitte wählen Sie neu.",
      "unbekannter_stil": "Diese Stilrichtung gibt es hier nicht mehr. Bitte laden Sie die Seite neu.",
      "ungueltige_einstellung": "Diese Einstellung kennt die Website nicht. Bitte laden Sie die Seite neu."
    },
    "einstellungen_titel": "Schrift, Knöpfe, Kopf, Muster und Bewegung",
    "automatisch": "Automatisch",
    "automatisch_aktiv": "automatisch, folgt der Markenfarbe",
    "automatisch_hinweis": "Die Website leitet diese Farbe aus der Markenfarbe ab",
    "einstellung": {
      "titel_groesse": "Größe der Überschriften",
      "text_groesse": "Größe des Textes",
      "titel_staerke": "Stärke der Überschriften",
      "titel_abstand": "Buchstabenabstand der Überschriften",
      "knopf_stil": "Knöpfe",
      "kopf": "Kopfzeile beim Scrollen",
      "muster": "Muster im Hintergrund",
      "kopf_ueber_bild": "Kopfzeile über dem Bild im Einstieg",
      "bewegung": "Einblenden beim Scrollen",
      "parallaxe": "Große Bilder bewegen sich mit (Parallaxe)",
      "tempo": "Tempo der Einblendung",
      "fuss": "Fußzeile",
      "kopf_stil": "Aufbau der Kopfzeile",
      "handy_menue": "Menü auf dem Handy",
      "bild_look": "Bild-Look für alle Fotos"
    },
    "wert": {
      "titel_groesse": {
        "kompakt": "Kompakt",
        "normal": "Normal",
        "gross": "Groß",
        "sehr_gross": "Sehr groß"
      },
      "text_groesse": {
        "normal": "Normal",
        "gross": "Groß"
      },
      "titel_staerke": {
        "normal": "Normal",
        "halbfett": "Halbfett",
        "fett": "Fett"
      },
      "titel_abstand": {
        "eng": "Eng",
        "normal": "Normal",
        "weit": "Weit"
      },
      "knopf_stil": {
        "voll": "Gefüllt",
        "rahmen": "Mit Rahmen",
        "sanft": "Sanft getönt",
        "akzent_rahmen": "Feiner Rahmen in Akzentfarbe, mit Pfeil"
      },
      "kopf": {
        "mitlaufend": "Scrollt mit",
        "klebend": "Bleibt oben",
        "einblendend": "Verschwindet beim Lesen, kommt beim Hochscrollen"
      },
      "muster": {
        "keins": "Keins",
        "sterne": "Sternenhimmel (nur auf dunklem Seitenhintergrund)"
      },
      "kopf_ueber_bild": {
        "aus": "Darüber",
        "an": "Durchsichtig auf dem Bild (auf hellem Seitenhintergrund mit der hellen Fassung des Logos)"
      },
      "bewegung": {
        "aufsteigen": "Steigt leicht auf",
        "sanft": "Blendet sanft ein",
        "zoom": "Wächst leicht heran",
        "aus": "Keine Bewegung"
      },
      "parallaxe": {
        "aus": "Aus",
        "an": "An"
      },
      "tempo": {
        "ruhig": "Ruhig",
        "normal": "Normal",
        "lebhaft": "Lebhaft"
      },
      "fuss": {
        "standard": "Zweispaltig",
        "spalten": "In Spalten mit Überschriften",
        "schlicht": "Schlicht, mittig"
      },
      "kopf_stil": {
        "standard": "Logo links, Menü rechts",
        "mittig": "Logo und Menü mittig"
      },
      "handy_menue": {
        "liste": "Klappt als Liste auf",
        "vollbild": "Über den ganzen Bildschirm"
      },
      "bild_look": {
        "natur": "Natürlich",
        "warm": "Warm",
        "kuehl": "Kühl",
        "kraeftig": "Kräftig",
        "sanft": "Sanft",
        "schwarzweiss": "Schwarzweiß"
      }
    },
    "farbe": {
      "color-primary": "Markenfarbe (Knöpfe, Links, Akzente)",
      "color-text": "Textfarbe",
      "color-akzent": "Akzentfarbe (eingefärbte Wörter, Marker)",
      "color-kante": "Seitenhintergrund",
      "color-tief": "Dunkle Abschnitte"
    },
    "gruppe": {
      "marke": "Marken-Farben",
      "flaechen": "Flächen"
    },
    "paare_titel": "Schrift-Paare",
    "paare_hinweis": "Ein Klick setzt Überschrift und Text. Darunter lässt sich jede Schrift einzeln ändern."
  },
  "freigabe": {
    "titel": "Website freigeben",
    "text": "Wenn alles passt, geben Sie die Website hier frei. Erst danach geht sie zum ersten Mal online.",
    "knopf": "Website freigeben",
    "name": "Ihr Name",
    "gesehen": "Ich habe die Website angesehen und gebe sie zur Veröffentlichung frei.",
    "bestaetigen": "Freigeben",
    "erledigt": "Freigegeben von {name} am {datum}. Danke!"
  },
  "empfaenger": {
    "seitentitel": "Adresse bestätigen",
    "ok_titel": "Adresse bestätigt",
    "ok_text": "Anfragen über das Kontaktformular von {name} kommen ab jetzt an diese Adresse.",
    "ungueltig_titel": "Link gilt nicht",
    "ungueltig_text": "Der Link ist abgelaufen oder wurde schon benutzt. Bitte bei miraTEQ einen neuen anfordern."
  },
  "stock": {
    "suche": "Stockfotos suchen",
    "suche_platzhalter": "Was soll zu sehen sein? Englisch findet am meisten, z. B. thai massage",
    "quelle": "Quelle",
    "ausrichtung": "Ausrichtung",
    "ausrichtung_egal": "Jede Ausrichtung",
    "ausrichtung_quer": "Querformat",
    "ausrichtung_hoch": "Hochformat",
    "suchen": "Suchen",
    "sucht": "Sucht …",
    "herkunft": "Fotos von {anbieter}. Frei nutzbar, auch geschäftlich, ohne Nennung auf der Website. Keine Fotos von Menschen als Ihr Team verwenden.",
    "ergebnisse": "Gefundene Fotos",
    "nichts_gefunden": "Nichts gefunden. Versuchen Sie andere Wörter, auf Englisch findet sich meist mehr.",
    "uebernehmen": "Foto übernehmen: {name}",
    "uebernimmt": "Wird übernommen …",
    "fehler": {
      "kein_schluessel": "Für diese Quelle ist noch kein Schlüssel hinterlegt. miraTEQ richtet ihn unter Einstellungen, Reiter Claude, ein.",
      "gesperrt": "Die Quelle hat die Anfrage abgelehnt. Bitte versuchen Sie die andere Quelle oder später.",
      "netz": "Das hat nicht geklappt. Bitte versuchen Sie es noch einmal.",
      "nicht_gefunden": "Dieses Foto gibt es nicht mehr. Bitte wählen Sie ein anderes.",
      "zu_gross": "Das Foto ist zu groß. Bitte wählen Sie ein anderes.",
      "kein_bild": "Die Datei ist kein Bild. Bitte wählen Sie ein anderes Foto.",
      "verarbeitung": "Das Foto ließ sich nicht umwandeln. Bitte wählen Sie ein anderes.",
      "quelle_unbekannt": "Diese Quelle gibt es nicht."
    }
  },
  "bildquellen": {
    "titel": "Stockfotos",
    "text": "Schlüssel für Pexels und Pixabay, beide kostenlos. Damit finden Sie und Claude Fotos für die Website. Die Fotos werden auf die eigene Website geladen, nicht von dort eingebunden.",
    "schluessel_da": "Hinterlegt, endet auf {ende}",
    "schluessel_fehlt": "Kein Schlüssel hinterlegt",
    "neu": "Neuer Schlüssel für {quelle}",
    "speichern": "Speichern",
    "entfernen": "Entfernen",
    "gespeichert": "Gespeichert",
    "fehler_format": "Das sieht nicht nach einem Schlüssel aus. Bitte kopieren Sie ihn noch einmal."
  },
  "symbol": {
    "titel": "Symbol",
    "keins": "Keins",
    "haus": "Haus",
    "bad": "Bad",
    "schluessel": "Schlüssel",
    "palm": "Palme",
    "sand": "Strand",
    "lotus": "Lotus",
    "leaf": "Blatt",
    "compass": "Kompass",
    "dining": "Essen",
    "concierge": "Service-Glocke",
    "community": "Gemeinschaft",
    "award": "Auszeichnung",
    "lock": "Schloss",
    "coffee": "Kaffee",
    "calendar": "Kalender",
    "bed": "Bett",
    "view": "Aussicht",
    "size": "Größe",
    "guests": "Gäste",
    "healing": "Wohlbefinden",
    "mandala": "Mandala",
    "herbs": "Kräuter",
    "oil": "Öl",
    "candle": "Kerze",
    "clock": "Uhr",
    "phone": "Telefon",
    "mail": "Brief",
    "map": "Karte",
    "chat": "Gespräch",
    "wolke": "Wolke",
    "geld": "Geld",
    "schild": "Schild"
  },
  "ki_bild": {
    "beschreibung": "Was soll das Bild zeigen?",
    "beschreibung_platzhalter": "Zum Beispiel: Warm beleuchteter Massageraum mit Matte, gefalteten Handtüchern und Orchideen, Abendstimmung",
    "format": "Format",
    "format_quer": "Querformat (für den Einstieg)",
    "format_hoch": "Hochformat",
    "format_quadrat": "Quadrat",
    "erzeugen": "Bild erzeugen",
    "laeuft": "Wird erzeugt …",
    "laeuft_lang": "Google erzeugt das Bild, das dauert etwa 10 bis 30 Sekunden.",
    "uebrig": "Diesen Monat noch {n} Bild | Diesen Monat noch {n} Bilder",
    "hinweis": "Erzeugt mit KI von Google, etwa 10 Cent je Bild. Nie für Fotos vom Team, von Mitarbeitern oder Kunden.",
    "ergebnis": "Erzeugtes Bild",
    "fertig": "Das Bild liegt jetzt in der Mediathek.",
    "nehmen": "Dieses Bild nehmen",
    "fehler": {
      "nicht_eingerichtet": "KI-Bilder sind noch nicht eingerichtet. miraTEQ richtet den Zugang ein.",
      "grenze": "Die Grenze für KI-Bilder in diesem Monat ist erreicht. Bitte nehmen Sie ein Stockfoto oder ein eigenes Bild.",
      "beschreibung": "Bitte beschreiben Sie das Bild in höchstens 600 Zeichen.",
      "abgelehnt": "Google hat diese Beschreibung abgelehnt. Bitte beschreiben Sie das Bild anders, zum Beispiel ohne Personen.",
      "gesperrt": "Google hat den Zugang abgelehnt. Bitte melden Sie sich bei miraTEQ.",
      "netz": "Das hat nicht geklappt. Bitte versuchen Sie es noch einmal.",
      "kein_bild": "Google hat kein Bild geliefert. Bitte versuchen Sie es noch einmal.",
      "verarbeitung": "Das Bild ließ sich nicht ablegen. Bitte versuchen Sie es noch einmal."
    }
  },
  "anfragen": {
    "knopf": "Anfragen",
    "knopf_hinweis": "Was Besucher über das Kontaktformular geschickt haben",
    "titel": "Anfragen aus dem Kontaktformular",
    "frist": "Jede Anfrage kam auch per E-Mail. Nach sechs Monaten löscht das CMS sie automatisch.",
    "laedt": "Anfragen werden geladen …",
    "leer": "Noch keine Anfragen. Neue erscheinen hier, sobald jemand das Kontaktformular abschickt.",
    "email": "E-Mail",
    "telefon": "Telefon",
    "termin": "Wunschtermin",
    "personen": "Personen",
    "von_seite": "Gesendet von",
    "antworten": "Per E-Mail antworten",
    "loeschen": "Löschen",
    "loeschen_frage": "Diese Anfrage löschen? Das lässt sich nicht rückgängig machen.",
    "ja_loeschen": "Ja, löschen",
    "geloescht": "Anfrage gelöscht",
    "fehler_laden": "Die Anfragen ließen sich nicht laden. Bitte versuchen Sie es noch einmal.",
    "fehler_loeschen": "Die Anfrage ließ sich nicht löschen. Bitte laden Sie die Seite neu."
  },
  "video": {
    "waehlen": "Video wählen (MP4 oder WebM)",
    "laedt": "Video wird hochgeladen …",
    "hochgeladen": "Video hochgeladen. Speichern nicht vergessen.",
    "entfernen": "Entfernen",
    "nur_mp4": "Bitte ein Video als MP4 oder WebM wählen.",
    "zu_gross": "Das Video ist größer als 25 MB. Bitte kürzer oder kleiner speichern.",
    "hinweis": "Ohne Ton, kurz und als Schleife gedacht. Das Bild bleibt darunter: Es zeigt sich, solange das Video lädt, und bei allen, die weniger Bewegung oder Datensparen eingestellt haben.",
    "hochladen_fuer": "Video hochladen für {feld}"
  },
  "markenprofil": {
    "knopf": "Markenprofil",
    "titel": "Markenprofil",
    "einleitung": "Claude bekommt es bei jedem Auftrag mit, damit jeder Text gleich klingt. Es steht nicht auf der Website.",
    "feld": {
      "angebot": "Was der Betrieb anbietet",
      "zielgruppe": "Für wen",
      "ton": "Ton",
      "vermeiden": "Was nie in einem Text stehen soll",
      "fakten": "Feste Fakten",
      "anrede": "Anrede auf Deutsch"
    },
    "beispiel": {
      "angebot": "Thai-Massage und Spa in Lindau, seit 2015, drei Behandlungsräume",
      "zielgruppe": "Einheimische und Urlauber, die zur Ruhe kommen wollen",
      "ton": "ruhig, herzlich, ohne Übertreibung",
      "vermeiden": "Heilversprechen, „Wellness-Oase“",
      "fakten": "Inhaberin: Malee Sommer, Termine nur nach Vereinbarung"
    },
    "anrede": {
      "offen": "wie bisher",
      "sie": "Siezen",
      "du": "Duzen"
    },
    "speichern": "Speichern",
    "gespeichert": "Markenprofil gespeichert",
    "fehler_laden": "Das Markenprofil ließ sich nicht laden.",
    "fehler_speichern": "Das Markenprofil ließ sich nicht speichern. Vielleicht fehlt Ihrem Zugang das Recht, Texte zu bearbeiten."
  },
  "sprachen": {
    "knopf": "Sprachen",
    "knopf_hinweis": "Eine Sprache ergänzen oder freigeben",
    "titel": "Sprachen der Website",
    "haupt": "Hauptsprache",
    "in_arbeit": "in Arbeit",
    "live": "auf der Website",
    "mit_claude": "Mit Claude übersetzen",
    "freigeben": "Freigeben",
    "hinzufuegen": "Sprache ergänzen",
    "waehlen": "Sprache wählen",
    "anlegen": "Ergänzen",
    "hinweis": "Alle Texte der Hauptsprache werden als Ausgangspunkt kopiert. Die Vorschau zeigt die neue Sprache sofort; live geht sie erst nach der Übersetzung und „Freigeben“.",
    "ergaenzt": "{name} ergänzt, {n} Textdatei kopiert. | {name} ergänzt, {n} Textdateien kopiert.",
    "freigegeben": "{name} ist freigegeben und geht mit dem nächsten Veröffentlichen live."
  }
}
